<script>
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import Datatable from "@/router/layouts/table-datatable.vue";
import appConfig from "@/app.config";
import axios from "axios";
import Swal from "sweetalert2";
import { defineAsyncComponent, ref } from "vue";
import moment from "moment";
import { debounce } from "@/helpers/debounce";
import $ from "jquery";
import "vue-select/dist/vue-select.css";





const FormImportTahapan = defineAsyncComponent(async () => {
    await new Promise((r) => setTimeout(r, 500));
    return import("./form-import-tahapan-diklat.vue");
});

const FormAddPeserta = defineAsyncComponent(async () => {
    await new Promise((r) => setTimeout(r, 500));
    return import("./add-pra_pelaksanaan_peserta.vue");
});

const FormAddInstruktur = defineAsyncComponent(async () => {
    await new Promise((r) => setTimeout(r, 500));
    return import("./add-pra_pelaksanaan_instruktur.vue");
});

// const DetailRekapNilai = defineAsyncComponent(async () => {
//     await new Promise((r) => setTimeout(r, 500));
//     return import("./table-evaluasi-pra_pelaksanakan/table-detail-rekap-nilai.vue");
// });

const FormAddMateri = defineAsyncComponent(async () => {
    await new Promise((r) => setTimeout(r, 500));
    return import("./add-pra_pelaksanaan_materi.vue");
});

const FormAddPraktikum = defineAsyncComponent(async () => {
    await new Promise((r) => setTimeout(r, 500));
    return import("./add-pra_pelaksanaan_praktikum.vue");
});

const FormAddAkomodasi = defineAsyncComponent(async () => {
    await new Promise((r) => setTimeout(r, 500));
    return import("./add-pra_pelaksanaan_akomodasi.vue");
});

const FormEditMateri = defineAsyncComponent(async () => {
    await new Promise((r) => setTimeout(r, 500));
    return import("./edit-pra_pelaksanaan_materi.vue");
});

const FormUnggahUndangan = defineAsyncComponent(async () => {
    await new Promise((r) => setTimeout(r, 500));
    return import("./add-unggah_undangan.vue");
});

const AbsensiPeserta = defineAsyncComponent(async () => {
    await new Promise((r) => setTimeout(r, 500));
    return import("./absensi-peserta.vue");
});

const AbsensiInstruktur = defineAsyncComponent(async () => {
    await new Promise((r) => setTimeout(r, 500));
    return import("./absensi-instruktur.vue");
});

const RoomAkomodasi = defineAsyncComponent(async () => {
    await new Promise((r) => setTimeout(r, 500));
    return import("./detail-pra_pelaksanaan_room.vue");
});

const TableInstruktur = defineAsyncComponent(async () => {
    await new Promise((r) => setTimeout(r, 500));
    return import("./table-pra_pelaksanaan_instruktur.vue");
});

const TableTahapanDiklat = defineAsyncComponent(async () => {
    await new Promise((r) => setTimeout(r, 500));
    return import("./table-pra_pelaksanaan_tahapan_diklat.vue");
});

// const TableMateri = defineAsyncComponent(async () => {
//     await new Promise((r) => setTimeout(r, 500));
//     return import("./table-pra_pelaksanaan_materi.vue");
// });

const TablePraktikum = defineAsyncComponent(async () => {
    await new Promise((r) => setTimeout(r, 500));
    return import("./table-pra_pelaksanaan_praktikum.vue");
});

// const TableAkomodasi = defineAsyncComponent(async () => {
//     await new Promise((r) => setTimeout(r, 500));
//     return import("./table-pra_pelaksanaan_akomodasi.vue");
// });

const DetailPraktikum = defineAsyncComponent(async () => {
    await new Promise((r) => setTimeout(r, 500));
    return import("./detail-pra_pelaksanaan_praktikum.vue");
});

const TemplateSuratPemanggilan = defineAsyncComponent(async () => {
    await new Promise((r) => setTimeout(r, 500));
    return import("./template-surat-pemanggilan.vue");
});




export default {
    name: "ButtonComponent",
    page: {
        title: "Detail Pelaksanaan",
        meta: [{ name: "description", content: appConfig.description }],
    },

    

    components: {

        Layout,
        PageHeader,
        Datatable,
        FormAddPeserta,
        FormAddInstruktur,
        // FormAddInstrukturKelompok,

        FormImportTahapan,
       
        FormAddPraktikum,
        FormAddMateri,
        FormAddAkomodasi,
        FormEditMateri,
        FormUnggahUndangan,
        TableInstruktur,
        // TableMateri,
        // TableAkomodasi,
        TablePraktikum,
        DetailPraktikum,
        AbsensiPeserta,
        AbsensiInstruktur,
        TemplateSuratPemanggilan,
        RoomAkomodasi,
        TableTahapanDiklat,
        // DetailRekapNilai,
        
        
    },
    data() {
        let sortOrders = []; // select sortOrder

        // definisi kolom yang dipakai
        let columns = [
            { width: "175px", label: "#", name: "-" },
            { width: "25px", label: "No", name: "-" },
            { width: "75px", label: "Photo", name: "-" },
            { width: "250px", label: "Nama", name: "-" },
            { width: "125px", label: "NIP", name: "-" },
            { width: "125px", label: "Jenis", name: "-" },
            { width: "125px", label: "Agama", name: "-" },
            { width: "200px", label: "TGL", name: "-" },
            { width: "100px", label: "Email", name: "-" },
            { width: "100px", label: "No. Telepon", name: "-" },
            { width: "100px", label: "Golongan", name: "-" },
            { width: "100px", label: "Pangkat", name: "-" }, // jika tidak ada sorting kasih name dengan karakter -

            { width: "125px", label: "Jabatan", name: "jabatan_name" },
            { width: "125px", label: "Pendidikan Terakhir", name: "pendidikan_terakhir" },
            // { width: "200px", label: "Pola Penyelenggaraan", name: "-" },
            // { width: "200px", label: "Sumber Anggaran", name: "-" },
            { width: "200px", label: "Instansi", name: "-" },
            { width: "200px", label: "Alamat Instansi", name: "-" },
            { width: "200px", label: "Alamat Rumah", name: "-" },
            { width: "200px", label: "Status Perkawinan", name: "-" },
            { width: "200px", label: "Unit Eselon", name: "-" },
            { width: "200px", label: "Telepon dan Fax", name: "-" },
            // { width: "200px", label: "Unit Organisasi", name: "-" },
        //    { width: "150px", label: "Aksi", name: "-" },
        ];

        columns.forEach((column) => {
            sortOrders[column.name] = -1;
        });

        return {
            title: "Detail Data Pelaksanaan",
            items: [
                {
                    text: "Pelaksanaan",
                    href: "/",
                },
                {
                    text: "Data Pelaksanaan",
                    href: "/pra-pelaksanaan/pembelajaran",
                },
                {
                    text: "Detail Data Pelaksanaan",
                    active: true,
                },
            ],


            user_role: localStorage.getItem("session_role_active_id"),

            keyTahapanDiklat: 0,

            setupModalAdd: false,

            app_url: process.env.VUE_APP_URL,
            id: this.$route.params.id,
            nomor_surat: null,
            kode: null,
            judul: null,
            dasar_pelaksanaan: null,
            strategi: null,
            strategi_id: null,
            durasi_he: null,
            pbl_online: null,
            pbl_offline: null,
            durasi_jp: null,
            tanggal_mulai: null,
            tanggal_selesai: null,
            tanggal_hari_ini: moment(ref(new Date())).format("YYYY-MM-DD"),
            learning_type: null,
            angkatan: null,
            strategi_model: null,
            

            status_submit: null,
            status_materi: null,
            status_akomodasi: null,
            status_kehadiran: null,
            status_instruktur: null,
            status_laporan: null,
            status_absensi_peserta: false,
            pembelajaran_status_peserta: null,
            pembelajaran_status_peserta_lms: null,
            status_button_verif_all_peserta: false,

            akomodasi_generate_at: null,
            feedback_peserta: null,
            feedback_peserta_temp: null,
            tot_budget_plan: null,
            tot_budget_confirm: null,
            tot_budget_fix: null,

            multipleSend: [],
            instrukturDuplikat: [],
            akomodasiDuplikat: [],
            materiDuplikat: [],
            praktikumDuplikat: [],
            idMateri: null,

            peserta_pembelajaran: [],
            domainPhoto: process.env.VUE_APP_BACKEND_URL,
            photoActive: '',
            photoNameActive: '',

            // photoDefault: self.domainPhoto +

            link_wa_grup: null,
            pembelajaran_kelas: null,
            jumlah_peserta_bersedia: null,
            jumlah_peserta_tidak_bersedia: null,
            status_konfirmasi_panitia: false,
            status_unggah_undangan: "peserta",
            tipeSuratPemanggilan: 1,

            pratikum: null,
            pratikum_data: null,

            pic: null,

            idPraktikumSelected: null,

            showFormAddPeserta: false,
            showFormAddInstruktur: false,
            showFormAddInstrukurKelompok: false,
            showFormAddMateri: false,
            showFormAddAkomodasi: false,
            showFormAddPraktikum: false,
            showFormEditMateri: false,
            showFormUnggahUndangan: false,
            showFormDetailPraktikum: false,
            showTableInstruktur: true,
            showTableMateri: true,
            showTablePraktikum: true,
            showTableAkomodasi: true,
            showDetailPraktikum: false,
            showFormAbsensiPeserta: false,
            showFormAbsensiInstruktur: false,
            showFeedbackPeserta: false,
            showKamar: false,
            showFormKamar: false,
            showFormTemplateSurat: false,
            showTableDiklat: false,

            selectStageAdd: '',
            currentStagesValueAdd: '',
            selectStageDisabled: true,
            listOptSelectStage: [],

            instruktur_data: [],
           
            peserta_ref: [],    

            // mkp_idAdd: "",
            titleMateriAdd: "",
            titleKelompokAdd: [],
            // instruktur_data:"",
            dateAgendaAdd: "",
            durationAgendaAdd: "",
            durationStartAdd: "",
            durationEndAdd: "",
            selectInstrukturAdd: "",
            detailAgendaAdd: "",
            selectGroupAdd: "",
            
            linkAgendaAdd: "",
            linkFileAdd: "",
            linkVideoAdd: "",
            questionUploadAdd: "",
            questionOnlineMeetingAdd: "",
            uploadFilePdf: "",
            uploadFilePpt: "",
            kelompokInstrukturAdd: [],



            tableData: {
                draw: 0,
                length: 10,
                search: "",
                column: 0,
                dir: "asc",
                filter_status: "SEMUA DATA",
            },

            columns: columns,
            sortKey: "pbl_id", // sort key awal
            sortOrders: sortOrders,

            loadingTable: {
                dokumentasi: true,
            },

            showModal: {
                addDokumentasi: false,
                editDokumentasi: false,
                editPeserta: false,
                uploadNilaiPeserta: false,
                uploadEvaluasiPelatihan: false,
                showPhoto: false,
                importTahapan: false,
            },

            showModalImport: false,

            listOptKategoriDokumentasi: [],

            selectKategoriDokumentasiDisabled: true,

            dataDokumentasi: {
                lm_name: null,
                lm_description: null,
                remark: '',
                lm_link: null,

                pathUploadFile: null,
            },

            dataEdit: {
                lm_id: null,
                lm_name: null,
                linknilai1: null,
                remark: '',
                lm_link: null,

                pathUploadFile: null,
            },

            dataUploadNilaiPeserta: {
                namafilenilai1: null,
                namafilenilai2: null,
                namafilenilai3: null,
                linknilai1: null,
                linknilai2: null,
                linknilai3: null,

                pathFile1: null,
                pathFile2: null,
                pathFile3: null,
            },

            dataUploadEvaluasiPelatihan: {
                namafilenilai1: null,
                namafilenilai2: null,
                namafilenilai3: null,
                linknilai1: null,
                linknilai2: null,
                linknilai3: null,

                pathFile1: null,
                pathFile2: null,
                pathFile3: null,
            },

            dataTableDokumentasi: [],

            dataPesertaEdit:{
                id_peserta:null,
                name: null,
                nip: null,
                jabatan_lama: null,
                unit_lama: null
            }
        };
    },
    created() {
        this.searchDatatable = debounce(() => {
            this.getDataTablePeserta();
            // call fetch API to get results
        }, 500);
    },
    mounted() {
        let self = this;
        Swal.fire({
            title: '<i class="fas fa-spinner fa-spin"></i>',
            text: "Loading...",
            showConfirmButton: false,
            allowOutsideClick: false,
        });

        // get data pembelajaran
        var config = {
            method: "get",
            url:
                process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/pembelajaran",
            params: {
                id: self.id,
                tableData: self.tableData,
            },
            headers: {
                Accept: "application/json",
                Authorization: "Bearer " + localStorage.access_token,
            },
        };
        axios(config)
            .then(function (response) {
                var response_data = response.data;
                var response_data_fix = response_data.data;
                if (response_data.meta.code == 200) {
                    self.getDataDokumentasi();

                    var data_edit = response_data_fix.data_pembelajaran;
                    self.nomor_surat = data_edit.pbl_nomor_surat;
                    self.kode = data_edit.pbl_kode;
                    self.judul = data_edit.pbl_dasar_pelaksanaan;
                    self.dasar_pelaksanaan = data_edit.pbl_judul;
                    self.strategi = data_edit.pbl_strategi;
                    self.strategi_id = data_edit.pbl_strategi_id;
                    self.durasi_he = data_edit.pbl_durasi_he;
                    self.pbl_online = data_edit.pbl_he_online;
                    self.pbl_offline = data_edit.pbl_he_offline;
                    self.durasi_jp = data_edit.pbl_durasi_jp;
                    self.tanggal_mulai = data_edit.pbl_tgl_mulai;
                    self.tanggal_selesai = data_edit.pbl_tgl_selesai;
                    self.learning_type = data_edit.pbl_lt_name;
                    self.angkatan = data_edit.pbl_angkatan;
                    self.status_submit = data_edit.status_perencanaan;
                    self.status_materi = data_edit.status_materi;
                    self.status_akomodasi = data_edit.status_akomodasi;
                    self.status_kehadiran = data_edit.status_kehadiran;
                    self.status_instruktur = data_edit.status_instruktur;
                    self.status_laporan = data_edit.status_laporan;
                    self.pembelajaran_status_peserta = data_edit.status_peserta;
                    self.pembelajaran_status_peserta_lms = data_edit.status_peserta_lms;
                    self.akomodasi_generate_at = data_edit.pbl_generate_akomodasi_at;
                    self.tot_budget_plan = data_edit.pbl_tot_budget_plan;
                    self.tot_budget_confirm = data_edit.pbl_tot_budget_confirm;
                    self.tot_budget_fix = data_edit.pbl_tot_budget_fix;

                    self.materi_pdf = data_edit.file_pdf;
                    self.materi_ppt = data_edit.file_ppt;

                    self.showTableDiklat = true;

                    self.strategi_model = data_edit.strategi.ms_model;
                    self.feedback_peserta = data_edit.strategi.pbl_feedback;

                    self.peserta_pembelajaran = data_edit.pembelajaran_peserta;
                    console.clear();
                    console.log(self.peserta_pembelajaran);
                    self.link_wa_grup = data_edit.pbl_link_wa_grup;
                    self.pembelajaran_kelas = data_edit.pbl_kelas;
                    self.jumlah_peserta_bersedia =
                        response_data_fix.jumlah_peserta_bersedia;
                    self.jumlah_peserta_tidak_bersedia =
                        response_data_fix.jumlah_peserta_tidak_bersedia;
                    self.status_konfirmasi_panitia =
                        response_data_fix.status_konfirmasi_panitia;

                    self.pratikum = data_edit.pbl_pratikum;
                    if (data_edit.pembelajaran_pratikum != null) {
                        self.pratikum_data = data_edit.pembelajaran_pratikum;
                    }

                    if (data_edit.pic != null) {
                        self.pic =
                            `(${data_edit.pic.mp_kategori}) ` +
                            data_edit.pic.user.username +
                            " - " +
                            data_edit.pic.user.name;
                    }

                    if (self.tanggal_hari_ini >= data_edit.pbl_tgl_mulai) {
                        self.status_absensi_peserta = true;
                    } else {
                        self.status_absensi_peserta = false;
                    }
                    self.status_button_verif_all_peserta =
                        response_data_fix.status_button_verif_all;

                    self.showTableAkomodasi = false;
                    self.$nextTick(() => {
                        self.showTableAkomodasi = true;
                    });
                    Swal.close();
                } else {
                    Swal.close();
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: response_data_fix.data.message,
                    });
                }
            })
            .catch(function (error) {
                console.log(error);
                Swal.close();
            });

        self.getListCategoryDokumentasi();

        if(self.domainPhoto && self.domainPhoto.includes("http://127.0.0.1")){
            self.domainPhoto = "http://digita-backend.alfahuma.com:8128/";
        }
    },
    
    methods: {

//     submitData() {
//     // Pastikan instruktur_data tidak kosong atau memiliki nilai valid
//     const validData = this.instruktur_data.filter(row => row.instruktur_data && row.titleKelompokAdd.trim() !== '');

//     if (validData.length === 0) {
//       alert('Silakan isi semua kolom!');
//       return;
//     }

//     axios.post('/api/submit', {
//       instruktur_data: validData
//     })
//     .then(response => {
//       console.log('Data berhasil dikirim!', response.data);
//     })
//     .catch(error => {
//       console.error('Terjadi kesalahan saat mengirim data:', error);
//     });
//   },
    

        getDataTablePeserta() {
            let self = this;
            self.tableData.draw++;
            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
                allowOutsideClick: false,
            });
            // get data pembelajaran
            var config = {
                method: "get",
                url:
                    process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/pembelajaran",
                params: {
                    id: self.id,
                    tableData: self.tableData,
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };
            axios(config)
                .then(function (response) {
                    var response_data = response.data;
                    var response_data_fix = response_data.data;
                    if (response_data.meta.code == 200) {
                        var data_edit = response_data_fix.data_pembelajaran;
                        self.nomor_surat = data_edit.pbl_nomor_surat;
                        self.kode = data_edit.pbl_kode;
                        self.judul = data_edit.pbl_dasar_pelaksanaan;
                        self.dasar_pelaksanaan = data_edit.pbl_judul;
                        self.strategi = data_edit.pbl_strategi;
                        self.strategi_id = data_edit.pbl_strategi_id;
                        self.durasi_he = data_edit.pbl_durasi_he;
                        self.pbl_online = data_edit.pbl_he_online;
                        self.pbl_offline = data_edit.pbl_he_offline;
                        self.durasi_jp = data_edit.pbl_durasi_jp;
                        self.tanggal_mulai = data_edit.pbl_tgl_mulai;
                        self.tanggal_selesai = data_edit.pbl_tgl_selesai;
                        self.learning_type = data_edit.pbl_lt_name;
                        self.angkatan = data_edit.pbl_angkatan;
                        self.status_submit = data_edit.status_perencanaan;
                        self.status_materi = data_edit.status_materi;
                        self.status_akomodasi = data_edit.status_akomodasi;
                        self.status_kehadiran = data_edit.status_kehadiran;
                        self.status_instruktur = data_edit.status_instruktur;
                        self.status_laporan = data_edit.status_laporan;
                        self.pembelajaran_status_peserta = data_edit.status_peserta;
                        self.pembelajaran_status_peserta_lms = data_edit.status_peserta_lms;
                        self.akomodasi_generate_at = data_edit.pbl_generate_akomodasi_at;
                        self.tot_budget_plan = data_edit.pbl_tot_budget_plan;
                        self.tot_budget_confirm = data_edit.pbl_tot_budget_confirm;
                        self.tot_budget_fix = data_edit.pbl_tot_budget_fix;

                        self.showTableDiklat = true;

                        self.strategi_model = data_edit.strategi.ms_model;
                        self.feedback_peserta = data_edit.strategi.pbl_feedback;

                        self.peserta_pembelajaran = data_edit.pembelajaran_peserta;
                        console.log('peserta')
                        console.log(self.peserta_pembelajaran)


                        self.link_wa_grup = data_edit.pbl_link_wa_grup;
                        self.pembelajaran_kelas = data_edit.pbl_kelas;
                        self.jumlah_peserta_bersedia =
                            response_data_fix.jumlah_peserta_bersedia;
                        self.jumlah_peserta_tidak_bersedia =
                            response_data_fix.jumlah_peserta_tidak_bersedia;
                        self.status_konfirmasi_panitia =
                            response_data_fix.status_konfirmasi_panitia;

                        self.pratikum = data_edit.pbl_pratikum;
                        if (data_edit.pembelajaran_pratikum != null) {
                            self.pratikum_data = data_edit.pembelajaran_pratikum;
                        }

                        if (data_edit.pic != null) {
                            self.pic =
                                `(${data_edit.pic.mp_kategori}) ` +
                                data_edit.pic.user.username +
                                " - " +
                                data_edit.pic.user.name;
                        }

                        if (self.tanggal_hari_ini >= data_edit.pbl_tgl_mulai) {
                            self.status_absensi_peserta = true;
                        } else {
                            self.status_absensi_peserta = false;
                        }
                        self.status_button_verif_all_peserta =
                            response_data_fix.status_button_verif_all;

                        self.showTableAkomodasi = false;
                        self.$nextTick(() => {
                            self.showTableAkomodasi = true;
                        });
                        Swal.close();
                    } else {
                        Swal.close();
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: response_data_fix.data.message,
                        });
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    Swal.close();
                });
        },

        fullDateTimeFormat(datetime) {
            return moment(datetime).format("YYYY-MM-DD HH:mm:ss");
        },
        formTambahPeserta() {
            let self = this;
            self.showFormAddPeserta = false;
            self.$nextTick(() => {
                self.showFormAddPeserta = true;
            });
        },
        formTambahInstruktur() {
            let self = this;
            self.showFormAddInstruktur = false;
            self.$nextTick(() => {
                self.showFormAddInstruktur = true;
            });
        },
        formTambahInstrukurKelompok() {
            let self = this;
            self.showFormAddInstrukurKelompok = false;
            self.$nextTick(() => {
                self.showFormAddInstrukurKelompok = true;
            });
        },

        formTambahMateri() {
            let self = this;
            self.showFormAddMateri = false;
            self.$nextTick(() => {
                self.showFormAddMateri = true;
            });
        },
        formTambahAkomodasi() {
            let self = this;
            self.showFormAddAkomodasi = false;
            self.$nextTick(() => {
                self.showFormAddAkomodasi = true;
            });
        },
        formTambahPraktikum() {
            let self = this;
            self.showFormAddPraktikum = false;
            self.$nextTick(() => {
                self.showFormAddPraktikum = true;
            });
        },
        formEditMateri(id) {
            let self = this;
            self.showFormEditMateri = false;
            self.idMateri = id;
            self.$nextTick(() => {
                self.showFormEditMateri = true;
            });
        },
        formUnggahUndangan(status) {
            let self = this;
            self.status_unggah_undangan = status;
            console.log(status);
            self.showFormUnggahUndangan = false;
            self.$nextTick(() => {
                self.showFormUnggahUndangan = true;
            });
        },
        

        formAbsensiPeserta() {
            let self = this;
            self.showFormAbsensiPeserta = false;
            self.$nextTick(() => {
                self.showFormAbsensiPeserta = true;
            });
        },
        deleteStages(mkp_id_agenda) {
            Swal.fire({
                icon: 'danger',
                title: 'Remove Data',
                text: 'Yakin menghapus data tahapan id' + mkp_id_agenda,
                showCancelButton: true,
                showConfirmButton: true,
            });
        },
        formAbsensiInstruktur() {
            let self = this;
            self.showFormAbsensiInstruktur = false;
            self.$nextTick(() => {
                self.showFormAbsensiInstruktur = true;
            });
        },
        formDetailPraktikum(id) {
            let self = this;
            self.idPraktikumSelected = id;
            self.showFormDetailPraktikum = false;
            self.$nextTick(() => {
                self.showFormDetailPraktikum = true;
            });
        },
        feedbackPeserta() {
            let self = this;
            self.feedback_peserta_temp = self.feedback_peserta;
            self.showFeedbackPeserta = true;
        },
        formTemplateSurat(tipeSurat) {
            let self = this;
            self.showFormTemplateSurat = true;
            self.tipeSuratPemanggilan = tipeSurat;
        },
        updateFeedback() {
            let self = this;
            Swal.fire({
                title: '<i class="fa fa-spinner fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
            });

            let conf = {
                url:
                    process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/pembelajaran",
                method: "put",
                data: {
                    id: self.id,
                    feedback: self.feedback_peserta_temp,
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };

            axios(conf)
                .then((res) => {
                    console.log(res);
                    Swal.fire({
                        icon: "success",
                        title: "Berhasil",
                        text: `Berhasil update feedback`,
                        timer: 2000,
                        timerProgressBar: true,
                        showCancelButton: false,
                        showConfirmButton: false,
                    }).then((result) => {
                        /* Read more about handling dismissals below */
                        if (result.dismiss === Swal.DismissReason.timer) {
                            self.feedback_peserta = self.feedback_peserta_temp;
                            self.showFeedbackPeserta = false;
                        }
                    });
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        genAkomodasi() {
            let self = this;
            if (
                self.strategi_model == "HYBRID" &&
                (!self.pbl_offline || !self.pbl_online)
            ) {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Isi harian efektif online dan offline terlebih dahulu",
                });
                return;
            }

            Swal.fire({
                title: '<i class="fa fa-spinner fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
            });
            let conf = {
                url:
                    process.env.VUE_APP_BACKEND_URL_VERSION +
                    "transactions/pra-pelaksanaan/gen-akomodasi",
                method: "post",
                data: {
                    pblId: self.id,
                    strategiId: self.strategi_id,
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };

            axios(conf).then((res) => {
                Swal.fire({
                    icon: "success",
                    title: "Berhasil",
                    text: `Berhasil generate akomodasi`,
                    timer: 2000,
                    timerProgressBar: true,
                    showCancelButton: false,
                    showConfirmButton: false,
                }).then((result) => {
                    /* Read more about handling dismissals below */
                    if (result.dismiss === Swal.DismissReason.timer) {
                        self.akomodasi_generate_at = res.data.data[0].genAt;
                        self.tot_budget_plan = res.data.data[0].totBudgetPlan;
                        self.tot_budget_confirm = res.data.data[0].totBudgetConfirm;
                        self.tot_budget_fix = res.data.data[0].totBudgetFix;
                        self.showTableAkomodasi = false;
                        self.$nextTick(() => {
                            self.showTableAkomodasi = true;
                        });
                    }
                });
            });
        },
        refreshTableInstruktur(dataDuplicate) {
            let self = this;
            self.showFormAddInstruktur = false;
            self.showTableInstruktur = false;
            self.instrukturDuplikat = [];
            self.$nextTick(() => {
                self.instrukturDuplikat = dataDuplicate;
                console.log(dataDuplicate);
                self.showTableInstruktur = true;
            });
        },
        refreshTablePraktikum() {
            let self = this;
            self.showFormDetailPraktikum = false;
            self.showFormAddPraktikum = false;
            window.location.reload();
        },
        refreshTableMateri(dataDuplicate) {
            let self = this;
            self.showFormAddMateri = false;
            self.showFormEditMateri = false;
            self.showTableMateri = false;
            self.materiDuplikat = [];
            self.$nextTick(() => {
                self.showTableMateri = true;
                self.materiDuplikat = dataDuplicate;
            });
        },
        refreshTableAkomodasi(dataDuplicate) {
            let self = this;
            self.showFormAddAkomodasi = false;
            self.showTableAkomodasi = false;
            self.akomodasiDuplikat = [];
            self.$nextTick(() => {
                self.akomodasiDuplikat = dataDuplicate;
                console.log(dataDuplicate);
                self.showTableAkomodasi = true;
            });
        },
        updatePblOnlOff(pblOnlOff) {
            let self = this;
            self.pbl_online = pblOnlOff[0];
            self.pbl_offline = pblOnlOff[1];

            self.showTableAkomodasi = false;
            self.$nextTick(() => {
                self.showTableAkomodasi = true;
            });
        },
        closeFormUndangan() {
            let self = this;
            self.showFormUnggahUndangan = false;
        },
        closeFormAbsensiPeserta() {
            let self = this;
            self.showFormAbsensiPeserta = false;
        },
        closeFormAbsensiInstruktur() {
            let self = this;
            self.showFormAbsensiInstruktur = false;
            self.showTableInstruktur = false;
            self.$nextTick(() => {
                self.showTableInstruktur = true;
            });
        },
        confirmStatus(status) {
            var statusConf = "";
            if (status == "materi") {
                statusConf = "READY MATERI";
            } else if (status == "akomodasi") {
                statusConf = "READY AKOMODASI";
            } else if (status == "laporan") {
                statusConf = "READY LAPORAN";
            }

            Swal.fire({
                title: "Perhatian",
                text: `Anda yakin untuk mengkonfirmasi ${status}?`,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: `Iya`,
                denyButtonText: `Tidak`,
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: '<i class="fa fa-spinner fa-spin"></i>',
                        text: "Loading...",
                        showConfirmButton: false,
                    });

                    var config = {
                        method: "put",
                        url:
                            process.env.VUE_APP_BACKEND_URL_VERSION +
                            "transactions/pembelajaran",
                        data: {
                            id: this.id,
                            status: statusConf,
                            user_id: localStorage.getItem("session_user_id"),
                        },
                        headers: {
                            Accept: "application/json",
                            Authorization: "Bearer " + localStorage.access_token,
                        },
                    };
                    axios(config).then((response) => {
                        var response_data = response.data;
                        if (response_data.meta.code != "200") {
                            Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: response_data.data.message,
                            });
                        } else {
                            Swal.fire({
                                icon: "success",
                                title: "Berhasil",
                                text: `Berhasil konfirmasi ${status}.`,
                                timer: 2000,
                                timerProgressBar: true,
                                showCancelButton: false,
                                showConfirmButton: false,
                            }).then((result) => {
                                /* Read more about handling dismissals below */
                                if (result.dismiss === Swal.DismissReason.timer) {
                                    location.reload();
                                }
                            });
                        }
                    });
                } else {
                    Swal.close();
                }
            });
        },
        konfirmasiPesertaLMS() {
            Swal.fire({
                title: "Perhatian",
                text: `Anda yakin untuk mengkonfirmasi semua data peserta LMS?`,
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: `Iya`,
                denyButtonText: `Tidak`,
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: '<i class="fa fa-spinner fa-spin"></i>',
                        text: "Loading...",
                        showConfirmButton: false,
                    });

                    var config_konfirm_peserta_lms = {
                        method: "put",
                        url:
                            process.env.VUE_APP_BACKEND_URL_VERSION +
                            "transactions/pembelajaran/konfirmasi-peserta",
                        data: {
                            id: this.id,
                            user_id: localStorage.getItem("session_user_id"),
                        },
                        headers: {
                            Accept: "application/json",
                            Authorization: "Bearer " + localStorage.access_token,
                        },
                    };
                    axios(config_konfirm_peserta_lms).then((response) => {
                        var response_data = response.data;
                        if (response_data.meta.code != "200") {
                            Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: response_data.data.message,
                            });
                        } else {
                            if (response_data.data.status == true) {
                                Swal.fire({
                                    icon: "success",
                                    title: "Berhasil",
                                    text: `Berhasil Konfirmasi Peserta LMS.`,
                                    timer: 2000,
                                    timerProgressBar: true,
                                    showCancelButton: false,
                                    showConfirmButton: false,
                                }).then((result) => {
                                    /* Read more about handling dismissals below */
                                    if (result.dismiss === Swal.DismissReason.timer) {
                                        location.reload();
                                    }
                                });
                            } else {
                                Swal.fire({
                                    icon: "error",
                                    title: "Oops...",
                                    text: "Semua peserta telah di verifikasi oleh panitia.",
                                });
                            }
                        }
                    });
                } else {
                    Swal.close();
                }
            });
        },
        kirimUndanganPeserta(key_data, id_pembelajaran, id_peserta) {
            let self = this;
            Swal.fire({
                title: '<i class="fa fa-spinner fa-spin"></i>',
                text: "Loading Kirim Undangan...",
                showConfirmButton: false,
            });

            var config_kirim_undangan = {
                method: "put",
                url:
                    process.env.VUE_APP_BACKEND_URL_VERSION +
                    "transactions/pra-pelaksanaan/undangan-peserta",
                data: {
                    id_pembelajaran: id_pembelajaran,
                    id_peserta: id_peserta,
                    user_id: localStorage.getItem("session_user_id"),
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };

            axios(config_kirim_undangan).then((response) => {
                var response_data = response.data;
                if (response_data.meta.code != "200") {
                    Swal.fire({
                        icon: "error",
                        title: "Oops...",
                        text: response_data.data.message,
                    });
                } else {
                    if (response_data.data.status == true) {
                        Swal.fire({
                            icon: "success",
                            title: "Berhasil",
                            text: `Berhasil Kirim Undangan ke Nomor Whatsapp Peserta LMS.`,
                            timer: 2000,
                            timerProgressBar: true,
                            showCancelButton: false,
                            showConfirmButton: false,
                        }).then((result) => {
                            /* Read more about handling dismissals below */
                            if (result.dismiss === Swal.DismissReason.timer) {
                                self.peserta_pembelajaran[key_data].status_peserta =
                                    "MENUNGGU KONFIRMASI";
                            }
                        });
                    } else if (response_data.data.status == "nothing") {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Mohon isi link Grup WA, kelas dan unggah surat undangan peserta.",
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: "Data Peserta tidak ditemukan.",
                        });
                    }
                }
            });
        },
        kirimUndanganPesertaMultiple() {
            let self = this;
            if (self.multipleSend != "") {
                Swal.fire({
                    title: '<i class="fa fa-spinner fa-spin"></i>',
                    text: "Loading Kirim Undangan...",
                    showConfirmButton: false,
                });

                var config_kirim_undangan_multiple = {
                    method: "put",
                    url:
                        process.env.VUE_APP_BACKEND_URL_VERSION +
                        "transactions/pra-pelaksanaan/undangan-peserta-multiple",
                    data: {
                        id_pembelajaran: self.id,
                        peserta: JSON.stringify(self.multipleSend),
                        user_id: localStorage.getItem("session_user_id"),
                    },
                    headers: {
                        Accept: "application/json",
                        Authorization: "Bearer " + localStorage.access_token,
                    },
                };

                axios(config_kirim_undangan_multiple).then((response) => {
                    var response_data = response.data;
                    if (response_data.meta.code != "200") {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: response_data.data.message,
                        });
                    } else {
                        if (response_data.data.status == true) {
                            Swal.fire({
                                icon: "success",
                                title: "Berhasil",
                                text: `Berhasil Kirim Undangan ke Nomor Whatsapp Peserta LMS yang terpilih.`,
                                timer: 2000,
                                timerProgressBar: true,
                                showCancelButton: false,
                                showConfirmButton: false,
                            }).then((result) => {
                                /* Read more about handling dismissals below */
                                if (result.dismiss === Swal.DismissReason.timer) {
                                    window.location.reload();
                                }
                            });
                        } else if (response_data.data.status == "nothing") {
                            Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: "Mohon isi link Grup WA, kelas dan unggah surat undangan peserta.",
                            });
                        } else {
                            Swal.fire({
                                icon: "error",
                                title: "Oops...",
                                text: "Gagal Kirim Undangan ke Nomor Whatsapp Peserta LMS yang terpilih.",
                            });
                        }
                    }
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Mohon pilih peserta.",
                });
            }
        },
        simpanLinkWAKelas() {
            let self = this;
            if (self.link_wa_grup != null && self.pembelajaran_kelas != "") {
                Swal.fire({
                    title: '<i class="fa fa-spinner fa-spin"></i>',
                    text: "Loading...",
                    showConfirmButton: false,
                });

                var config_link_dan_kelas = {
                    method: "put",
                    url:
                        process.env.VUE_APP_BACKEND_URL_VERSION +
                        "transactions/pra-pelaksanaan/link-grup-kelas",
                    data: {
                        id_pembelajaran: self.id,
                        link_wa_grup: self.link_wa_grup,
                        kelas: self.pembelajaran_kelas,
                        user_id: localStorage.getItem("session_user_id"),
                    },
                    headers: {
                        Accept: "application/json",
                        Authorization: "Bearer " + localStorage.access_token,
                    },
                };

                axios(config_link_dan_kelas).then((response) => {
                    var response_data = response.data;
                    if (response_data.meta.code != "200") {
                        Swal.close();
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: response_data.data.message,
                        });
                    } else {
                        Swal.close();
                        Swal.fire({
                            icon: "success",
                            title: "Berhasil",
                            text: "Data Link WA Group dan Kelas Berhasil Disimpan",
                            timer: 2000,
                            timerProgressBar: true,
                            showCancelButton: false,
                            showConfirmButton: false,
                        }).then((result) => {
                            /* Read more about handling dismissals below */
                            if (result.dismiss === Swal.DismissReason.timer) {
                                // window.location.reload();
                            }
                        });
                    }
                });
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Mohon Isi Link WA Group dan Kelas.",
                });
            }
        },

        downloadFile() {
            const link = document.createElement("a");
            link.href = "/template_excel/template_peserta.xlsx";
            link.download = "/template_excel/template_peserta.xlsx";
            link.click();
        },

        uploadFile() {
            let self = this;
            if ($("#importexcel")[0].files[0]) {
                if ($("#importexcel")[0].files[0].size < 2242880) {
                    $("#uploadLoadingExcel").html(
                        '<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>'
                    );
                    var urlres = process.env.VUE_APP_BACKEND_URL;
                    var FormData = require("form-data");
                    var data = new FormData();
                    data.append("file", $("#importexcel")[0].files[0]);
                    var config = {
                        method: "post",
                        url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
                        headers: {
                            Accept: "application/json",
                            Authorization: "Bearer " + localStorage.access_token,
                        },
                        data: data,
                    };
                    axios(config).then(function (response) {
                        console.log(response.data.data.path_file);
                        var path_file = response.data.data.path_file;
                        urlres += path_file;
                        $("#uploadLoadingExcel").html(
                            '<span class="badge bg-success p-1"><i class="fa fa-check"></i> Berhasil </span> <a href="' +
                            urlres +
                            '" target="_blank" style="padding-left:10px;"><span class="badge bg-success p-1"><i class="fa fa-eye"></i> Lihat File</span></a>'
                        );
                        self.file_excel = path_file;
                    });
                }
            }
        },


        ImportData() {
            let self = this;
            self.showModal = false;
            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading... menyimpan data",
                showConfirmButton: false,
            });

            var config_store_data = {
                method: "post",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/peserta/import-peserta",
                data: {
                    path_file: self.file_excel,
                    id: self.id,
                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };

            axios(config_store_data).then(function (response) {
                console.log(response);
                Swal.fire({
                    icon: "success",
                    title: "Berhasil",
                    text: "Import Data Berhasil",
                    timer: 2000,
                    timerProgressBar: true,
                    showCancelButton: false,
                    showConfirmButton: false,
                }).then((result) => {
                    if (result.dismiss === Swal.DismissReason.timer) {
                        Swal.close();
                        self.showModalImport = false;
                        self.getDataTablePeserta();
                    }
                });
            }).catch(function (error) {
                self.axiosCatchError = error.response.data.data;
                Swal.close();
            });
        },

       
        
        exportTahapanDiklatToPDF() {
    Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading Ekspor Data ...",
        showConfirmButton: false,
        allowOutsideClick: false,
    });

    const config = {
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/pra-pelaksanaan/materi/export-pdf",
        responseType: 'blob',
        withCredentials: true,
        crossDomain: true,
        params: {
            idPembelajaran: this.id,
            user_id: localStorage.getItem("session_user_id"),
        },
        headers: {
            Accept: "application/pdf",  // Adjusted to request PDF
            Authorization: "Bearer " + localStorage.getItem("access_token"),
        },
    };

    axios(config).then(function (response) {
        const resStatus = response.status;
        if (resStatus === 200) {
            Swal.close();

            // Create a Blob from the response data (PDF)
            const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
            const link = document.createElement('a');
            link.href = url;

            // Create a filename with today's date
            const filename = 'Data Tahapan Diklat ' + new Date().toISOString().slice(0, 10) + '.pdf';
            link.setAttribute('download', filename);
            
            // Trigger the download
            document.body.appendChild(link);
            link.click();
            link.remove();

            // Success message
            Swal.fire({
                icon: 'success',
                title: 'Berhasil',
                text: 'Data berhasil diekspor dalam format PDF',
            });
        }
    }).catch(function (error) {
        Swal.close();
        Swal.fire({
            icon: 'error',
            title: 'Gagal',
            text: 'Terjadi kesalahan saat mengekspor data',
        });
        console.error("Error exporting data:", error);
    });
},

        exportTahapanDiklat() {
            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading Ekspor Data ...",
                showConfirmButton: false,
                allowOutsideClick: false,
            });

            var config = {
                method: "get",
                url:
                    process.env.VUE_APP_BACKEND_URL_VERSION +
                    "transactions/pra-pelaksanaan/materi/export",
                responseType: 'blob',
                withCredentials: true,
                crossDomain: true,
                params: {
                    idPembelajaran: this.id,
                    user_id: localStorage.getItem("session_user_id"),
                },
                headers: {
                    Accept: "application/vnd.ms-excel",
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };

            axios(config).then(function (response) {
                var resStatus = response.status;
                if (resStatus == 200) {
                    Swal.close();
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const filename = 'Data Tahapan Diklat' + new Date().toISOString().slice(0, 10) + '.xlsx';
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    Swal.fire({
                        icon: 'success',
                        title: 'Berhasil',
                        text: 'Data Peserta berhasil di ekspor',
                    });
                }
            });
        },

        exportPeserta() {

            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading Ekspor Data ...",
                showConfirmButton: false,
                allowOutsideClick: false,
            });

            var config = {
                method: "get",
                url:
                    process.env.VUE_APP_BACKEND_URL_VERSION +
                    "transactions/pra-pelaksanaan/peserta/export",
                responseType: 'blob',
                crossDomain: true,
                params: {
                    idPembelajaran: this.id,
                    user_id: localStorage.getItem("session_user_id"),
                },
                headers: {
                    Accept: "application/vnd.ms-excel",
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };

            axios(config).then(function (response) {
                var resStatus = response.status;
                if (resStatus == 200) {
                    Swal.close();
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    const filename = 'Data Peserta Pembelajaran' + new Date().toISOString().slice(0, 10) + '.xlsx';
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    Swal.fire({
                        icon: 'success',
                        title: 'Berhasil',
                        text: 'Data Peserta berhasil di ekspor',
                    });
                }
            });
        },

        deletePeserta(pls_id, nama){
            let self = this;
            Swal.fire({
                title: 'Hapus peserta',
                text: 'Yakin menghapus user '+nama,
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Ya',
                cancelButtonText: 'Batal',
                customClass:{
                    confirmButton: 'btnSucces',
                    cancelButton: 'btnDanger'
                }
            }).then((result)=>{
                if(result.isConfirmed){
                    Swal.fire({
                        title: '<i class="fas fa-spinner fa-spin"></i>',
                        text: "Loading...",
                        showConfirmButton: false,
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    });

                    var config = {
                        method: "delete",
                        url: process.env.VUE_APP_BACKEND_URL_VERSION+"transactions/pra-pelaksanaan/delete-peserta",
                        params:{
                            id_pls:pls_id,
                            id_pbl:self.id,
                        },
                        headers: {
                            Accept: "application/json",
                            Authorization: "Bearer "+localStorage.access_token,
                        }
                    };
                    axios(config).then((response)=>{
                       if(response.data.meta.code == 200){
                        Swal.fire({
                            icon: "success",
                            title: "Berhasil",
                            text: "Data berhasil diperbarui.",
                            timer: 2000,
                            timerProgressBar: true,
                            showCancelButton: false,
                            showConfirmButton: false,
                        }).then((result) => {
                            /* Read more about handling dismissals below */
                            if (result.dismiss === Swal.DismissReason.timer) {
                                self.getDataTablePeserta();
                            }
                        });
                        
                        
                       }else{
                        Swal.fire({
                         icon: "error",
                         title: "Oops...",
                         text: response.data.message
                        })
                       }
                    })
                }else{
                    Swal.close();
                }
            })
        },

        editPeserta(id){
        let self = this;
        Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
        });
    
        var config = {
          method: "get",
          url:  process.env.VUE_APP_BACKEND_URL_VERSION + "/peserta",
          params:{
            id_user:id,
            id_pbl:self.id,
          },
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
         },
        };
        axios(config).then((response)=>
        {

            if(response.data.meta.code == 200){
               self.dataPesertaEdit.id_peserta = response.data.data[0].pls_id_peserta,
               self.dataPesertaEdit.name = response.data.data[0].user.name,
               self.dataPesertaEdit.nip = response.data.data[0].user.nip,
               self.dataPesertaEdit.jabatan_lama = response.data.data[0].pls_jabatan_lama,
               self.dataPesertaEdit.unit_lama = response.data.data[0].pls_unit_lama
              Swal.close();
              self.showModal.editPeserta = true;
            }
        })
        },

        storePeserta(){
        let self = this;
        Swal.fire({
        title: '<i class="fas fa-spinner fa-spin"></i>',
        text: "Loading...",
        showConfirmButton: false,
        });

        var config = {
            method: "put",
            url: process.env.VUE_APP_BACKEND_URL_VERSION + "transactions/pra-pelaksanaan/peserta/edit",
            data:{
                id_user:self.dataPesertaEdit.id_peserta,
                id_pbl:self.id,
                pls_jabatan_lama: self.dataPesertaEdit.jabatan_lama,
                pls_unit_lama: self.dataPesertaEdit.unit_lama
            },
            headers: {
                Accept: "application/json",
                Authorization: "Bearer " + localStorage.access_token,
            },
        };

            axios(config)
            .then((response)=>{
                if(response.status == 200){
                    Swal.fire({
                    icon: "success",
                    title: "Berhasil",
                    text: "Data berhasil di sunting.",
                    showConfirmButton: false,
                    })
                    self.showModal.editPeserta = false;

                    self.getDataTablePeserta(self.id)
                }else {
                    Swal.fire({
                    icon: 'error',
                    title: 'Failed',
                    text: 'Something went wrong !',
                    showConfirmButton: true,
                    });
        }
              })
        },

        checkKamar() {
            let self = this;
            self.showFormKamar = false;
            self.$nextTick(() => {
                self.showFormKamar = true;
                self.showKamar = true;
            });
        },
        verifAll() {
            let self = this;
            var data_peserta = self.peserta_pembelajaran;
            data_peserta.forEach((value) => {
                if (
                    value.status_peserta == "TERVERIFIKASI PANITIA" ||
                    value.status_peserta == "MENUNGGU KONFIRMASI"
                ) {
                    var cek_data = self.multipleSend.indexOf(value.pls_id);
                    if (cek_data == -1) {
                        self.multipleSend.push(value.pls_id);
                    }
                }
            });
            console.log(self.multipleSend);
        },
        getListTypeStages() {
            let self = this;
            self.selectStageDisabled = true;

            var config = {
                method: 'get',
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/kode-pembelajaran/list-type-agenda",
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token
                },
            };

            axios(config).then((response) => {
                var resStatus = response.status;
                if (resStatus == 200) {
                    self.selectStageDisabled = false;
                    self.listOptSelectStage = response.data.data[0];
                } else {
                    self.selectStageDisabled = true;
                }
            }).catch((error) => {
                console.log('Error:', error.response ? error.response.data : error.message);
                self.selectStageDisabled = true;
            });
        },
        setupStagesAdd() {
            this.setupModalAdd = true;
            this.selectStageAdd = '';

            // this.mkp_idAdd = mkp_id;
            this.resetFormStagesAdd();
            this.getListTypeStages();
        },

        addRowPeserta() {
            console.log(typeof(this.instruktur_data));
        this.instruktur_data.push({
        instruktur_data: self.instruktur_data,
        kelompok_instruktur: self.titleKelompokAdd,
        // instruktur_data: null, // Set default value
        // kelompok_instruktur: '', // Set default value for kelompok
      });
    },

    // Hapus baris tertentu
    deleteRow(index) {
      this.instruktur_data.splice(index, 1);
    },

    // Cari instruktur berdasarkan input
    onSearchInstruktur(search, loading) {
      if (search.length) {
        loading(true);
        this.searchPeserta(loading, search);
      }
    },

    // Metode untuk memanggil API pencarian instruktur
    searchPeserta(loading, search) {
      const config = {
        method: "get",
        url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/search-instruktur",
        params: { search },
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.access_token,
        },
      };

      axios(config)
        .then((response) => {
          if (response.data?.meta?.code === 200) {
            this.peserta_ref = response.data.data.referensi;
          } else {
            this.peserta_ref = [{ user_id: 0, username: "-" }];
          }
          loading(false);
        })
        .catch(() => {
          this.peserta_ref = [{ user_id: 0, username: "-" }];
          loading(false);
        });
    },

      uploadFilePdff(event) {
      const file = event.target.files[0];
      const errorMessage = this.isValidPdf(file, this.maxFileSize);

      // Update error message jika ada, atau tampilkan pesan sukses
      if (errorMessage) {
        this.errorMessage = errorMessage;
        document.getElementById("uploadLoadingPdf").innerText = this.errorMessage;
      } else {
        this.uploadFilePdf = file; 
        this.errorMessage = "";
        document.getElementById("uploadLoadingPdf").innerText = "File siap diunggah.";
      }
      console.log(this.uploadFilePdf); 
    },
    isValidPdf(file, maxFileSize) {
      if (!file) {
        return "Silakan pilih file terlebih dahulu.";
      }
      if (file.type !== "application/pdf") {
        return "File harus dalam format PDF.";
      }
      if (file.size > maxFileSize) {
        return "Ukuran file maksimal adalah 2 MB.";
      }
      return ""; // File valid
    },

    uploadFilePptt(event) {
      const file = event.target.files[0];
      const errorMessage = this.isValidPpt(file, this.maxFileSize);

      // Update error message jika ada, atau tampilkan pesan sukses
      if (errorMessage) {
        this.errorMessage = errorMessage;
        document.getElementById("uploadLoadingPpt").innerText = this.errorMessage;
      } else {
        this.uploadFilePpt = file; 
        this.errorMessage = "";
        document.getElementById("uploadLoadingPpt").innerText = "File siap diunggah.";
      }
      console.log(this.uploadFilePpt); 
    },

    isValidPpt(file, maxFileSize) {
    if (!file) {
        return "Silakan pilih file terlebih dahulu.";
    }
    // Cek tipe file apakah PPT atau PPTX
    if (file.type !== "application/vnd.ms-powerpoint" && file.type !== "application/vnd.openxmlformats-officedocument.presentationml.presentation") {
        return "File harus dalam format PPT atau PPTX.";
    }
    if (file.size > maxFileSize) {
        return "Ukuran file maksimal adalah 2 MB.";
    }
    return ""; // File valid
},

        selectStagesAdd() {
            if (this.notEmptyFormStagesAdd()) {
                Swal.fire({
                    title: 'Tipe Tahapan Diganti',
                    html: 'Beberapa input di form Tahapan sudah terisi<br>Apakah tipe tahapan tetap akan diganti ?<br><small style="color:red;">*Isi form akan dikosongkan</small>',
                    icon: 'warning',
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonText: 'Ya, ganti tahapan',
                    cancelButtonText: 'Tidak'
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.titleMateriAdd = "";
                        this.questionUploadAdd = "";
                        this.questionOnlineMeetingAdd = "";

                        this.currentStagesValueAdd = this.selectStageAdd;

                        this.resetFormStagesAdd();
                    } else {
                        this.selectStageAdd = this.currentStagesValueAdd;
                    }
                })
            } else {
                this.currentStagesValueAdd = this.selectStageAdd;
            }
        },
        closeModalStagesAdd() {
            if (this.notEmptyFormStagesAdd()) {
                Swal.fire({
                    title: 'Tutup Form Tahapan ?',
                    text: 'Beberapa input pada form Tahapan sudah terisi\nBila form di tutup, maka isi form akan kosongkan !',
                    icon: 'warning',
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonText: 'Tutup Form Tahapan',
                    cancelButtonText: 'Batal',
                    customClass: {
                        confirmButton: 'btnSuccess',
                        cancelButton: 'btnDanger',
                    },
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.resetFormStagesAdd();
                    } else {
                        this.setupModalAdd = true;
                    }
                });
            }
        },
        confirmResetFormStagesAdd() {
            if (this.notEmptyFormStagesAdd()) {
                Swal.fire({
                    icon: 'warning',
                    title: 'Form Tidak Kosong !',
                    text: 'Beberapa input pada form Tahapan sudah terisi\nApa Tetap akan dihapus ?',
                    showConfirmButton: true,
                    showCancelButton: true,
                    confirmButtonText: 'Ya, bersihkan form',
                    cancelButtonText: 'Batal',
                }).then((result) => {
                    if (result.isConfirmed) {
                        this.resetFormStagesAdd();
                    }
                });
            }
        },
        notEmptyFormStagesAdd() {
            if (
                this.titleMateriAdd ||
                this.dateAgendaAdd ||
                this.durationAgendaAdd ||
                this.detailAgendaAdd ||
                // this.titleKelompokAdd || 
                this.durationStartAdd ||
                this.durationEndAdd ||
                // this.instruktur_data ||

                this.selectGroupAdd ||
                this.linkAgendaAdd ||
                this.linkFileAdd ||
                this.linkVideoAdd ||
                this.questionUploadAdd ||
                this.uploadFilePdf ||
                this.uploadFilePpt ||

                this.questionOnlineMeetingAdd
            ) {
                return true;
            } else {
                return false;
            }
        },
        resetFormStagesAdd() {
            // this.mkp_idAdd = "";
            this.titleMateriAdd = "";
            this.dateAgendaAdd = "";
            this.durationAgendaAdd = "";
            this.durationStartAdd = "";
            this.durationEndAdd = ""
            this.detailAgendaAdd = "";
        

            this.selectGroupAdd = "";
            this.kelompokInstrukturAdd = "";
            this.linkAgendaAdd = "";
            this.linkFileAdd = "";
            this.linkVideoAdd = "";
            this.questionUploadAdd = "";
            this.questionOnlineMeetingAdd = "";
            this.uploadFilePdf ="";
            this.uploadFilePpt ="";
            this.instruktur_data=[];
            this.titleKelompokAdd=[];
        },
        testsendparent(satu){
            console.log(satu)
        },

//         DataInstruktur() {
//   // Kosongkan array sebelum menambahkan data baru
//         let instrukturdata = this.instruktur_data;
//         let titleKelompok = [];

//         instrukturdata.forEach((data) => {
//             if (data.data_instruktur) {
//             instrukturdata.push(data.data_instruktur.user_id);
//             }
//             if (data.titleKelompokAdd) {
//             titleKelompok.push(data.titleKelompokAdd);
//             }
//         }); 
//         this.instruktur_data = instrukturdata;
//         this.titleKelompokAdd = titleKelompok;
//         console.log(this.instruktur_data);
//         },


DataInstruktur() {
  // Variabel sementara untuk menyimpan id instruktur dan kelompok
  let userIds = [];
  let titleKelompok = [];

  this.instruktur_data.forEach((data) => {
    // Simpan hanya user_id ke dalam array userIds
    if (data.data_instruktur && data.data_instruktur.user_id) {
      userIds.push(data.data_instruktur.user_id);
    }
    // Simpan titleKelompokAdd ke dalam array titleKelompok
    if (data.titleKelompokAdd) {
      titleKelompok.push(data.titleKelompokAdd);
    }
  });

  // Assign array user_id dan titleKelompok ke property komponen
  this.instruktur_data = userIds; // Hanya berisi user_id
  this.titleKelompokAdd = titleKelompok;

  console.log("Kelompok Instruktur:", this.titleKelompokAdd);
  console.log("Instruktur IDs:", this.instruktur_data);
},

        storeDataStages() {

            // this.DataInstruktur();
            
            let self = this;
            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
            });
            var configStoreData = {
                method: "post",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/kode-pembelajaran/addAgenda",
                data: {
                    id: self.id,
                    kode_pembelajaran: self.kode,
                    judul: self.judul,
                    type_stages: self.selectStageAdd,
                    title_agenda: self.titleMateriAdd,
                    date_agenda: self.dateAgendaAdd,
                    duration_agenda: self.durationAgendaAdd,
                    duration_start: self.durationStartAdd,
                    duration_end: self.durationEndAdd,
                    detail_agenda: self.detailAgendaAdd,
                   
                    group: self.selectGroupAdd,
                    link_agenda: self.linkAgendaAdd,
                    link_file: self.linkFileAdd,
                    link_video: self.linkVideoAdd,
                    is_upload: self.questionUploadAdd,
                    is_online_meet: self.questionOnlineMeetingAdd,
                    materi_pdf: self.uploadFilePdf,
                    materi_ppt: self.uploadFilePpt,
                    kelompok_instruktur: JSON.stringify(this.titleKelompokAdd),
                    instruktur: JSON.stringify(this.instruktur_data),
                },
                
                headers: {
                    Accept: "application/json",
                    "Content-Type" : "multipart/form-data",
                    Authorization: "Bearer " + localStorage.access_token,
                }
            };

        

            axios(configStoreData)
                .then(function (response) {
                    console.log(response);
                    Swal.fire({
                        icon: "success",
                        title: "Berhasil",
                        text: "Data berhasil di simpan !",
                        timer: 2000,
                        timerProgressBar: true,
                        showCancelButton: false,
                        showConfirmButton: false,
                    }).then((result) => {
                        if (result.dismiss === Swal.DismissReason.timer) {
                            Swal.close();
                            // self.$router.push({ name: "all-kode-pembelajaran" });
                            self.resetFormStagesAdd();
                            self.setupModalAdd = false;
                            self.keyTahapanDiklat += 1;
                        }
                    });
                })
                .catch(function (error) {
                    console.error();
                    self.axiosCatchError = error.response.data.data;
                    Swal.close();
                });
        },

        sortBy(key) {
            let self = this;
            self.sortKey = key;
            self.sortOrders[key] = self.sortOrders[key] * -1;
            self.tableData.column = self.getIndex(self.columns, "name", key);
            self.tableData.dir = self.sortOrders[key] === 1 ? "asc" : "desc";
            self.getDataTablePeserta();
        },

        getIndex(array, key, value) {
            return array.findIndex((i) => i[key] == value);
        },

        showModalUploadNilaiPeserta() {
            let self = this;
            self.showModal.uploadNilaiPeserta = true;
        },

        storeDataUploadNilaiPeserta() {
            let self = this;
            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
            });
            var configStoreData = {
                method: "post",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/kode-pembelajaran/nilai-peserta",
                params:{
                    id:self.id
                },
                data: {
                    file_name1: self.dataUploadNilaiPeserta.namafilenilai1,
                    file_name2: self.dataUploadNilaiPeserta.namafilenilai2,
                    file_name3: self.dataUploadNilaiPeserta.namafilenilai3,

                    link_file1: self.dataUploadNilaiPeserta.linknilai1,
                    link_file2: self.dataUploadNilaiPeserta.linknilai2,
                    link_file3: self.dataUploadNilaiPeserta.linknilai3,

                    path_file1: self.dataUploadNilaiPeserta.pathFile1,
                    path_file2: self.dataUploadNilaiPeserta.pathFile2,
                    path_file3: self.dataUploadNilaiPeserta.pathFile3,

                    created_by: localStorage.session_user_id,

                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                }
            };

            axios(configStoreData).then(function (response) {
                var resStatus = response.status;

                if (resStatus === 200) {
                    Swal.fire({
                        icon: "success",
                        title: "Berhasil",
                        text: "Data berhasil di simpan !",
                        timer: 2000,
                        timerProgressBar: true,
                        showCancelButton: false,
                        showConfirmButton: false,
                    }).then((result) => {
                        if (result.dismiss === Swal.DismissReason.timer) {
                            Swal.close();
                            self.showModal.uploadNilaiPeserta = false;

                            self.clearFormuploadNilaiPeserta();
                            // self.loadingTable.dokumentasi = true;
                            // self.getDataDokumentasi();
                            // self.$nextTick(() => {
                            //     self.showTableMateri = true;
                            // });
                        }
                    });
                }
            }).catch(function (error) {
                self.axiosCatchError = error.response.data.data;
                Swal.close();
            });
        },

        clearFormuploadNilaiPeserta() {
            let self = this;

            self.dataUploadNilaiPeserta.namafilenilai1 = null;
            self.dataUploadNilaiPeserta.namafilenilai2 = null;
            self.dataUploadNilaiPeserta.namafilenilai3 = null;
            self.dataUploadNilaiPeserta.linknilai1 = null;
            self.dataUploadNilaiPeserta.linknilai2 = null;
            self.dataUploadNilaiPeserta.linknilai3 = null;
            self.dataUploadNilaiPeserta.pathFile1 = null;
            self.dataUploadNilaiPeserta.pathFile2 = null;
            self.dataUploadNilaiPeserta.pathFile3 = null;

            $('#formPhoto').val('');
            $("#uploadLoading").empty();
        },


        inputFilePhoto1() {
    let self = this;
    if ($("#formPhoto1")[0].files[0]) {
        if ($("#formPhoto1")[0].files[0].size < 5242880) {
            $("#uploadLoading1").html('<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>');

            var urlres = process.env.VUE_APP_BACKEND_URL;
            var FormData = require("form-data");
            var data = new FormData();
            data.append("file", $("#formPhoto1")[0].files[0]); // Perbaikan ID input file
            var config = {
                method: "post",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
                headers: {
                    Authorization: "Bearer " + localStorage.access_token,
                },
                data: data,
            };
            axios(config).then(function (response) {
                var path_file = response.data.data.path_file;
                urlres += path_file;
                $("#uploadLoading1").html(
                    '<span class="badge bg-success p-1"><i class="fa fa-check"></i> Berhasil </span> <a href="' +
                    urlres +
                    '" target="_blank" style="padding-left:10px;"><span class="badge bg-success p-1"><i class="fa fa-eye"></i> Lihat File</span></a>'
                );

                self.dataUploadNilaiPeserta.pathFile1 = path_file;
            });
        } else {
            alert("Max File 5 MB");
            $('#formPhoto1').val('');
        }
    }
},

        inputFilePhoto2() {
    let self = this;
    if ($("#formPhoto2")[0].files[0]) {
        if ($("#formPhoto2")[0].files[0].size < 5242880) {
            $("#uploadLoading2").html('<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>');

            var urlres = process.env.VUE_APP_BACKEND_URL;
            var FormData = require("form-data");
            var data = new FormData();
            data.append("file", $("#formPhoto2")[0].files[0]); // Perbaikan ID input file
            var config = {
                method: "post",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
                headers: {
                    Authorization: "Bearer " + localStorage.access_token,
                },
                data: data,
            };
            axios(config).then(function (response) {
                var path_file = response.data.data.path_file;
                urlres += path_file;
                $("#uploadLoading2").html(
                    '<span class="badge bg-success p-1"><i class="fa fa-check"></i> Berhasil </span> <a href="' +
                    urlres +
                    '" target="_blank" style="padding-left:10px;"><span class="badge bg-success p-1"><i class="fa fa-eye"></i> Lihat File</span></a>'
                );

                self.dataUploadNilaiPeserta.pathFile2 = path_file;
            });
        } else {
            alert("Max File 5 MB");
            $('#formPhoto2').val('');
        }
    }
},

inputFilePhoto3() {
    let self = this;
    if ($("#formPhoto3")[0].files[0]) {
        if ($("#formPhoto3")[0].files[0].size < 5242880) {
            $("#uploadLoading3").html('<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>');

            var urlres = process.env.VUE_APP_BACKEND_URL;
            var FormData = require("form-data");
            var data = new FormData();
            data.append("file", $("#formPhoto3")[0].files[0]); // Perbaikan ID input file
            var config = {
                method: "post",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
                headers: {
                    Authorization: "Bearer " + localStorage.access_token,
                },
                data: data,
            };
            axios(config).then(function (response) {
                var path_file = response.data.data.path_file;
                urlres += path_file;
                $("#uploadLoading3").html(
                    '<span class="badge bg-success p-1"><i class="fa fa-check"></i> Berhasil </span> <a href="' +
                    urlres +
                    '" target="_blank" style="padding-left:10px;"><span class="badge bg-success p-1"><i class="fa fa-eye"></i> Lihat File</span></a>'
                );

                self.dataUploadNilaiPeserta.pathFile3 = path_file;
            });
        } else {
            alert("Max File 5 MB");
            $('#formPhoto3').val('');
        }
    }
},

        showModalUploadEvaluasiPelatihan() {
            let self = this;
            self.showModal.uploadEvaluasiPelatihan = true;
        },

        storeDataUploadEvaluasiPelatihan() {
            let self = this;
            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
            });
            var configStoreData = {
                method: "post",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/kode-pembelajaran/nilai-evaluasi",
                params:{
                    id:self.id
                },
                data: {
                    file_name1: self.dataUploadEvaluasiPelatihan.namafilenilai1,
                    file_name2: self.dataUploadEvaluasiPelatihan.namafilenilai2,
                    file_name3: self.dataUploadEvaluasiPelatihan.namafilenilai3,

                    link_file1: self.dataUploadEvaluasiPelatihan.linknilai1,
                    link_file2: self.dataUploadEvaluasiPelatihan.linknilai2,
                    link_file3: self.dataUploadEvaluasiPelatihan.linknilai3,

                    path_file1: self.dataUploadEvaluasiPelatihan.pathFile1,
                    path_file2: self.dataUploadEvaluasiPelatihan.pathFile2,
                    path_file3: self.dataUploadEvaluasiPelatihan.pathFile3,

                    created_by: localStorage.session_user_id,

                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                }
            };

            axios(configStoreData).then(function (response) {
                var resStatus = response.status;

                if (resStatus === 200) {
                    Swal.fire({
                        icon: "success",
                        title: "Berhasil",
                        text: "Data berhasil di simpan !",
                        timer: 2000,
                        timerProgressBar: true,
                        showCancelButton: false,
                        showConfirmButton: false,
                    }).then((result) => {
                        if (result.dismiss === Swal.DismissReason.timer) {
                            Swal.close();
                            self.showModal.uploadEvaluasiPelatihan = false;

                            self.clearFormuploadEvaluasiPelatihan();
                            // self.loadingTable.dokumentasi = true;
                            // self.getDataDokumentasi();
                            // self.$nextTick(() => {
                            //     self.showTableMateri = true;
                            // });
                        }
                    });
                }
            }).catch(function (error) {
                self.axiosCatchError = error.response.data.data;
                Swal.close();
            });
        },

        clearFormuploadEvaluasiPelatihan() {
            let self = this;

            self.dataUploadEvaluasiPelatihan.namafilenilai1 = null;
            self.dataUploadEvaluasiPelatihan.namafilenilai2 = null;
            self.dataUploadEvaluasiPelatihan.namafilenilai3 = null;
            self.dataUploadEvaluasiPelatihan.linknilai1 = null;
            self.dataUploadEvaluasiPelatihan.linknilai2 = null;
            self.dataUploadEvaluasiPelatihan.linknilai3 = null;
            self.dataUploadEvaluasiPelatihan.pathFile1 = null;
            self.dataUploadEvaluasiPelatihan.pathFile2 = null;
            self.dataUploadEvaluasiPelatihan.pathFile3 = null;

            $('#formPhoto').val('');
            $("#uploadLoading").empty();
        },


        inputFilePhotoEvaluasi1() {
    let self = this;
    if ($("#formPhoto4")[0].files[0]) {
        if ($("#formPhoto4")[0].files[0].size < 5242880) {
            $("#uploadLoading1").html('<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>');

            var urlres = process.env.VUE_APP_BACKEND_URL;
            var FormData = require("form-data");
            var data = new FormData();
            data.append("file", $("#formPhoto4")[0].files[0]); // Perbaikan ID input file
            var config = {
                method: "post",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
                headers: {
                    Authorization: "Bearer " + localStorage.access_token,
                },
                data: data,
            };
            axios(config).then(function (response) {
                var path_file = response.data.data.path_file;
                urlres += path_file;
                $("#uploadLoading4").html(
                    '<span class="badge bg-success p-1"><i class="fa fa-check"></i> Berhasil </span> <a href="' +
                    urlres +
                    '" target="_blank" style="padding-left:10px;"><span class="badge bg-success p-1"><i class="fa fa-eye"></i> Lihat File</span></a>'
                );

                self.dataUploadEvaluasiPelatihan.pathFile1 = path_file;
            });
        } else {
            alert("Max File 5 MB");
            $('#formPhoto4').val('');
        }
    }
},

        inputFilePhotoEvaluasi2() {
    let self = this;
    if ($("#formPhoto5")[0].files[0]) {
        if ($("#formPhoto5")[0].files[0].size < 5242880) {
            $("#uploadLoading5").html('<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>');

            var urlres = process.env.VUE_APP_BACKEND_URL;
            var FormData = require("form-data");
            var data = new FormData();
            data.append("file", $("#formPhoto5")[0].files[0]); // Perbaikan ID input file
            var config = {
                method: "post",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
                headers: {
                    Authorization: "Bearer " + localStorage.access_token,
                },
                data: data,
            };
            axios(config).then(function (response) {
                var path_file = response.data.data.path_file;
                urlres += path_file;
                $("#uploadLoading5").html(
                    '<span class="badge bg-success p-1"><i class="fa fa-check"></i> Berhasil </span> <a href="' +
                    urlres +
                    '" target="_blank" style="padding-left:10px;"><span class="badge bg-success p-1"><i class="fa fa-eye"></i> Lihat File</span></a>'
                );

                self.dataUploadEvaluasiPelatihan.pathFile2 = path_file;
            });
        } else {
            alert("Max File 5 MB");
            $('#formPhoto5').val('');
        }
    }
},

inputFilePhotoEvaluasi3() {
    let self = this;
    if ($("#formPhoto6")[0].files[0]) {
        if ($("#formPhoto6")[0].files[0].size < 5242880) {
            $("#uploadLoading6").html('<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>');

            var urlres = process.env.VUE_APP_BACKEND_URL;
            var FormData = require("form-data");
            var data = new FormData();
            data.append("file", $("#formPhoto6")[0].files[0]); // Perbaikan ID input file
            var config = {
                method: "post",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
                headers: {
                    Authorization: "Bearer " + localStorage.access_token,
                },
                data: data,
            };
            axios(config).then(function (response) {
                var path_file = response.data.data.path_file;
                urlres += path_file;
                $("#uploadLoading6").html(
                    '<span class="badge bg-success p-1"><i class="fa fa-check"></i> Berhasil </span> <a href="' +
                    urlres +
                    '" target="_blank" style="padding-left:10px;"><span class="badge bg-success p-1"><i class="fa fa-eye"></i> Lihat File</span></a>'
                );

                self.dataUploadEvaluasiPelatihan.pathFile3 = path_file;
            });
        } else {
            alert("Max File 5 MB");
            $('#formPhoto6').val('');
        }
    }
},

        showModalAddDokumentasi() {
            let self = this;
            self.showModal.addDokumentasi = true;
        },

        getDataDokumentasi() {
            let self = this;
            self.loadingTable.dokumentasi = true;

            var config = {
                method: 'get',
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/kode-pembelajaran/dokumentasi",
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token
                },
                params:{
                    id: self.id
                }
            }

            axios(config).then((response) => {
                var resStatus = response.status;

                if (resStatus === 200) {
                    var resData = response.data.data[0];

                    self.loadingTable.dokumentasi = false;
                    self.dataTableDokumentasi = resData;
                }
            }).catch((error) => {
                self.loadingTable.dokumentasi = false;
                console.log(error);
            });
        },

        getListCategoryDokumentasi() {
            let self = this;
            self.selectKategoriDokumentasiDisabled = true;

            var config = {
                method: 'get',
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/kode-pembelajaran/list-category-documentation",
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token
                },
            };

            axios(config).then((response) => {
                var resStatus = response.status;
                if (resStatus == 200) {
                    var resData = response.data.data[0];

                    self.listOptKategoriDokumentasi = resData;
                    self.selectKategoriDokumentasiDisabled = false;

                } else {
                    self.selectKategoriDokumentasiDisabled = true;
                }
            }).catch((error) => {
                console.log('Error:', error.response ? error.response.data : error.message);
                self.selectKategoriDokumentasiDisabled = true;
            });
        },

        openFileDokumentasi(pathFile) {
            var file = process.env.VUE_APP_BACKEND_URL + pathFile;
            window.open(file, '_blank');
        },

        storeDataAddDokumentasi() {
            let self = this;
            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
            });
            var configStoreData = {
                method: "post",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/kode-pembelajaran/dokumentasi",
                params:{
                    id:self.id
                },
                data: {
                    lm_name: self.dataDokumentasi.lm_name,
                    lm_description: self.dataDokumentasi.lm_description,
                    lm_link: self.dataDokumentasi.lm_link,
                    remark: "KATEGORI_DOKUMENTASI_" + self.dataDokumentasi.remark,
                    created_by: localStorage.session_user_id,

                    path_file: self.dataDokumentasi.pathUploadFile,

                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                }
            };

            axios(configStoreData).then(function (response) {
                var resStatus = response.status;

                if (resStatus === 200) {
                    Swal.fire({
                        icon: "success",
                        title: "Berhasil",
                        text: "Data berhasil di simpan !",
                        timer: 2000,
                        timerProgressBar: true,
                        showCancelButton: false,
                        showConfirmButton: false,
                    }).then((result) => {
                        if (result.dismiss === Swal.DismissReason.timer) {
                            Swal.close();
                            self.showModal.addDokumentasi = false;

                            self.clearFormAddDokumentasi();
                            // self.refreshTableMateri();
                            // self.showTableMateri = false;
                            self.loadingTable.dokumentasi = true;
                            self.getDataDokumentasi();
                            // self.$nextTick(() => {
                            //     self.showTableMateri = true;
                            // });
                        }
                    });
                }
            }).catch(function (error) {
                self.axiosCatchError = error.response.data.data;
                Swal.close();
            });
        },

        editDocumentation(lm_id, pbl_id) {
            let self = this;

            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: 'Loading . . .',
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
            });

            var config = {
                method: 'get',
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/kode-pembelajaran/dokumentasi",
                params: {
                    lm_id: lm_id,
                    id: pbl_id,
                },
                headers: {
                    Accept: 'application/json',
                    Authorization: "Bearer " + localStorage.access_token,
                },
            };

            axios(config).then((response) => {
                console.log(response);
                var resStatus = response.status;

                if (resStatus === 200) {
                    var resData = response.data.data[0];

                    Swal.close();
                    self.showModal.editDokumentasi = true;

                    self.dataEdit.lm_id = resData.lm_id;
                    self.dataEdit.lm_name = resData.lm_name;
                    self.dataEdit.lm_link = resData.lm_link;
                    self.dataEdit.lm_description = resData.lm_description;
                    self.dataEdit.remark = resData.remark.replace('KATEGORI_DOKUMENTASI_', '');

                    self.dataEdit.pathUploadFile = resData.materi_pembelajaran_dokumen.lmd_path_file;

                    $("#uploadLoadingEdit").html(
                        '<span class="badge bg-success p-1">' +
                        '<i class="fa fa-check"></i> Berhasil' +
                        '</span> ' +

                        '<a href="' + process.env.VUE_APP_BACKEND_URL + resData.materi_pembelajaran_dokumen.lmd_path_file + '" target="_blank" style="padding-left:10px;">' +
                        '<span class="badge bg-success p-1">' +
                        '<i class="fa fa-eye"></i> Lihat File' +
                        '</span>' +
                        '</a>'
                    );
                }
            }).catch((error) => {
                Swal.fire({
                    icon: 'warning',
                    title: 'Error !',
                    text: 'Something went wrong !\n' + error,
                    showConfirmButton: true,
                });
            });

        },

        storeDataEditDokumentasi() {
            let self = this;
            Swal.fire({
                title: '<i class="fas fa-spinner fa-spin"></i>',
                text: "Loading...",
                showConfirmButton: false,
                allowOutsideClick: false,
                allowEscapeKey: false,
            });
            var configStoreData = {
                method: "put",
                url: process.env.VUE_APP_BACKEND_URL_VERSION + "master/kode-pembelajaran/dokumentasi",
                data: {
                    lm_id: self.dataEdit.lm_id,
                    lm_name: self.dataEdit.lm_name,
                    lm_description: self.dataEdit.lm_description,
                    lm_link: self.dataEdit.lm_link,
                    remark: "KATEGORI_DOKUMENTASI_" + self.dataEdit.remark,
                    updated_by: localStorage.session_user_id,

                    path_file: self.dataEdit.pathUploadFile,

                },
                headers: {
                    Accept: "application/json",
                    Authorization: "Bearer " + localStorage.access_token,
                }
            };

            axios(configStoreData).then(function (response) {
                var resStatus = response.status;

                if (resStatus === 200) {
                    Swal.fire({
                        icon: "success",
                        title: "Berhasil",
                        text: "Data berhasil di update !",
                        timer: 2000,
                        timerProgressBar: true,
                        showCancelButton: false,
                        showConfirmButton: false,
                    }).then((result) => {
                        if (result.dismiss === Swal.DismissReason.timer) {
                            Swal.close();
                            self.showModal.editDokumentasi = false;

                            self.clearFormAddDokumentasi();
                            // self.refreshTableMateri();
                            // self.showTableMateri = false;
                            self.loadingTable.dokumentasi = true;
                            self.getDataDokumentasi();
                            // self.$nextTick(() => {
                            //     self.showTableMateri = true;
                            // });
                        }
                    });
                }
            }).catch(function (error) {
                self.axiosCatchError = error.response.data.data;
                Swal.close();
            });
        },

        deleteDocumentation(lm_id) {
            let self = this;

            Swal.fire({
                icon: 'warning',
                title: 'Delete this data !',
                text: 'Are you sure to remove this data ?',
                showConfirmButton: true,
                showCancelButton: true,
            }).then((result) => {
                if (result.isConfirmed) {
                    Swal.fire({
                        title: '<i class="fas fa-spinner fa-spin"></i>',
                        text: "Loading...",
                        showConfirmButton: false,
                        allowOutsideClick: false,
                    });

                    var config = {
                        method: 'delete',
                        url: process.env.VUE_APP_BACKEND_URL_VERSION + 'master/kode-pembelajaran/dokumentasi',
                        data: {
                            lm_id: lm_id
                        },
                        headers: {
                            Accept: 'application/json',
                            Authorization: "Bearer " + localStorage.access_token,
                        },
                    };

                    axios(config).then((response) => {
                        var resStatus = response.status;
                        if (resStatus == 200) {
                            Swal.fire({
                                icon: 'success',
                                title: 'Success',
                                text: 'Success delete data',
                                timer: 2000,
                                timerProgressBar: true,
                                showCancelButton: false,
                                showConfirmButton: false,
                            }).then((result) => {
                                if (result.dismiss === Swal.DismissReason.timer) {
                                    self.loadingTable.dokumentasi = true;
                                    self.getDataDokumentasi();

                                    Swal.close();
                                }
                            });
                        }
                    }).catch((error) => {
                        Swal.fire({
                            title: 'Error',
                            text: 'Something went wrong !\n' + error,
                            icon: 'warning',
                            showConfirmButton: true,
                        });
                    });
                }
            });
        },

        clearFormAddDokumentasi() {
            let self = this;

            self.dataDokumentasi.lm_name = null;
            self.dataDokumentasi.lm_description = null;
            self.dataDokumentasi.lm_link = null;
            self.dataDokumentasi.remark = '';
            self.dataDokumentasi.pathUploadFile = null;

            self.dataEdit.lm_id = null;
            self.dataEdit.lm_name = null;
            self.dataEdit.lm_description = null;
            self.dataEdit.lm_link = null;
            self.dataEdit.remark = '';
            self.dataEdit.pathUploadFile = null;

            $('#formPhoto').val('');
            $("#uploadLoading").empty();
        },

        inputFilePhoto() {
            let self = this;
            if ($("#formPhoto")[0].files[0]) {
                if ($("#formPhoto")[0].files[0].size < 5242880) {
                    // let fileName = $("#formPhoto")[0].files[0].name;
                    // let fileExtension = fileName.split('.').pop().toLowerCase();

                    $("#uploadLoading").html('<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>');

                    var urlres = process.env.VUE_APP_BACKEND_URL;
                    var FormData = require("form-data");
                    var data = new FormData();
                    data.append("file", $("#formPhoto")[0].files[0]);
                    var config = {
                        method: "post",
                        url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
                        headers: {
                            Authorization: "Bearer " + localStorage.access_token,
                        },
                        data: data,
                    };
                    axios(config).then(function (response) {
                        // console.log(response.data.data.path_file);
                        var path_file = response.data.data.path_file;
                        urlres += path_file;
                        $("#uploadLoading").html(
                            '<span class="badge bg-success p-1"><i class="fa fa-check"></i> Berhasil </span> <a href="' +
                            urlres +
                            '" target="_blank" style="padding-left:10px;"><span class="badge bg-success p-1"><i class="fa fa-eye"></i> Lihat File</span></a>'
                        );

                        self.dataDokumentasi.pathUploadFile = path_file;
                    });
                } else {
                    alert("Max File 5 MB");
                    $('#formPhoto').val('');
                }
            }
        },

        inputFileEditPhoto() {
            let self = this;
            if ($("#formPhotoEdit")[0].files[0]) {
                if ($("#formPhotoEdit")[0].files[0].size < 5242880) {
                    // let fileName = $("#formPhotoEdit")[0].files[0].name;
                    // let fileExtension = fileName.split('.').pop().toLowerCase();

                    $("#uploadLoadingEdit").html('<span class="badge bg-warning p-1"><i class="fa fa-refresh fa-spin"></i> Loading...</span>');

                    var urlres = process.env.VUE_APP_BACKEND_URL;
                    var FormData = require("form-data");
                    var data = new FormData();
                    data.append("file", $("#formPhotoEdit")[0].files[0]);
                    var config = {
                        method: "post",
                        url: process.env.VUE_APP_BACKEND_URL_VERSION + "referensi/upload",
                        headers: {
                            Authorization: "Bearer " + localStorage.access_token,
                        },
                        data: data,
                    };
                    axios(config).then(function (response) {
                        // console.log(response.data.data.path_file);
                        var path_file = response.data.data.path_file;
                        urlres += path_file;
                        $("#uploadLoadingEdit").html(
                            '<span class="badge bg-success p-1"><i class="fa fa-check"></i> Berhasil </span> <a href="' +
                            urlres +
                            '" target="_blank" style="padding-left:10px;"><span class="badge bg-success p-1"><i class="fa fa-eye"></i> Lihat File</span></a>'
                        );

                        self.dataEdit.pathUploadFile = path_file;
                    });
                } else {
                    alert("Max File 5 MB");
                    $('#formPhotoEdit').val('');
                }
            }
        },

        showPhoto(photo, name){
            let self = this;

            self.showModal.showPhoto = true;
            self.photoNameActive = name;
            self.photoActive = self.domainPhoto + photo;
        },

        closePhoto(){
            let self = this;

            self.showModal.showPhoto = false;
            self.photoNameActive = '';
            self.photoActive = '';
        },

        showModalImportTahapan(){
            this.showModal.importTahapan = true;
        },

        closeModalImportTahapan(){
            this.showModal.importTahapan = false;
        },

        refreshTableDiklat(){
            this.showTableDiklat = false;
            this.$nextTick(() => {
                this.showTableDiklat = true;
            });
        },

    },
};
</script>
<style>

.photoBox{
	display: block;
	width: 50px; height: 50px;
	aspect-ratio: 1/1;
	/* border-radius: 5px; */
    overflow: hidden;
    margin: 0 auto;
}

.photoBox img{
	object-fit: cover;
	object-position: center;
}

</style>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="row">
                    <div class="col-12 text-end mb-3">

                    </div>
                </div>

                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12">
                                    <b-card header-class="bg-transparent border-primary" class="border border-primary">
                                        <template v-slot:header>
                                            <h5 class="my-0 text-primary d-flex justify-content-between align-items-center">
                                                <span>
                                                    <i class="mdi mdi-calendar-edit me-3"></i>
                                                    Formulir Perencanaan Pembelajaran
                                                </span>

                                                <router-link :to="{ name: 'all-pra-pembelajaran' }" class="btn btn-danger pull-right"><i class="fa fa-arrow-left"></i> <b>Kembali</b></router-link>
                                            </h5>
                                        </template>
                                        <div class="card-body p-0">
                                            <div class="row">
                                                <div class="col-3">
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <h5 class="font-size-12">
                                                                <span class="text-dark">Nomor Surat</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">{{ nomor_surat }}</p>
                                                            <hr style="margin:0 !important;">
                                                        </div>
                                                        <div class="col-12">
                                                            <h5 class="font-size-12">
                                                                <span class="text-dark">Kode Pembelajaran</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">{{ kode }}</p>
                                                            <hr style="margin:0 !important;">
                                                        </div>
                                                        <div class="col-12">
                                                            <h5 class="font-size-12">
                                                                <span class="text-dark">Dasar Pelaksanaan</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">
                                                                {{ dasar_pelaksanaan }}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-3">
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <h5 class="font-size-12">
                                                                <span class="text-dark">Judul Pembelajaran</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">{{ judul }}</p>
                                                            <hr style="margin:0 !important;">
                                                        </div>
                                                        <div class="col-12">
                                                            <h5 class="font-size-12">
                                                                <span class="text-dark">Strategi</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">{{ strategi }}</p>
                                                            <hr style="margin:0 !important;">
                                                        </div>
                                                        <div class="col-12">
                                                            <h5 class="font-size-12">
                                                                <span class="text-dark">Tipe Pembelajaran</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">{{ learning_type }}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-3">
                                                    <div class="row">
                                                        <div class="col-12">
                                                            <h5 class="font-size-12">
                                                                <span class="text-dark">PIC</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">{{ pic }}</p>
                                                            <hr style="margin:0 !important;">
                                                        </div>
                                                        <div class="col-12">
                                                            <h5 class="font-size-12">
                                                                <span class="text-dark">Angkatan</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">{{ angkatan }}</p>
                                                            <hr style="margin:0 !important;">
                                                        </div>
                                                        <div class="col-12">
                                                            <h5 class="font-size-12">
                                                                <span class="text-dark">Pratikum</span>
                                                            </h5>
                                                            <p class="text-muted mb-0 font-size-11">{{ pratikum }}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-3">
                                                    <div class="col-12">
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <h5 class="font-size-12 mb-1">
                                                                    <span class="text-dark">Durasi Hari Efektif (HE)</span>
                                                                </h5>
                                                                <p class="text-muted mb-0 font-size-11">{{ durasi_he }}</p>
                                                                <hr style="margin:0 !important;">
                                                            </div>
                                                            <div class="col-12">
                                                                <h5 class="font-size-12 mb-1">
                                                                    <span class="text-dark">Durasi Jam Pembelajaran (JP)</span>
                                                                </h5>
                                                                <p class="text-muted mb-0 font-size-11">{{ durasi_jp }}</p>
                                                                <hr style="margin:0 !important;">
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-12">
                                                        <div class="row">
                                                            <div class="col-12">
                                                                <h5 class="font-size-12 mb-1">
                                                                    <span class="text-dark">Tanggal Mulai</span>
                                                                </h5>
                                                                <p class="text-muted mb-0 font-size-11">
                                                                    {{ tanggal_mulai }}
                                                                </p>
                                                                <hr style="margin:0 !important;">
                                                            </div>
                                                            <div class="col-12">
                                                                <h5 class="font-size-12 font-size-12">
                                                                    <span class="text-dark">Tanggal Selesai</span>
                                                                </h5>
                                                                <p class="text-muted mb-0 font-size-11">
                                                                    {{ tanggal_selesai }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- <div class="row mt-3">
                                                <div class="col-md-12">
                                                    <router-link :to="`/data-pembelajaran/pra-pelaksanaan/detailEvaluasi/` + id" class="btn btn-info" v-if="user_role != 7">
                                                        <i class="fas fa-book-open"></i>
                                                        &nbsp;
                                                        <b>Detail Evaluasi Nilai</b>
                                                    </router-link>
                                                    &nbsp;
                                                    <router-link :to="`/data-pembelajaran/pra-pelaksanaan/detailEvaluasiPenyelenggaraan/` + id" class="btn btn-info">
                                                        <i class="fas fa-book"></i>
                                                        &nbsp;
                                                        <b>Detail Evaluasi Penyelenggaraan</b>
                                                    </router-link>
                                                    &nbsp;
                                                    <router-link :to="`/data-pembelajaran/pra-pelaksanaan/detailTenagaAhli/` + id" class="btn btn-info" v-if="user_role != 7 && user_role != 8">
                                                        <i class="fas fa-address-book"></i>
                                                        &nbsp;
                                                        <b>Detail Evaluasi Tenaga Ahli</b>
                                                    </router-link>
                                                </div>
                                            </div> -->

                                            <!-- TAMBAHAN -->
                                            <div class="row mt-3">
                                                <div class="col-md-12">
                                                    <!-- &nbsp;
                                                    <button type="button" class="btn btn-info btn-md text-bold" @click="showModalUploadNilaiPeserta()">
                                                    <i class="fa fa-upload"></i>
                                                &nbsp;
                                                     Upload Nilai Peserta
                                                </button> -->

                                                &nbsp;
                                                <router-link :to="`/data-pembelajaran/pra-pelaksanaan/detailUploadNilai/` + id" class="btn btn-info" v-if="user_role != 7 && user_role != 8">
                                                    <i class="fa fa-upload"></i>
                                                    &nbsp;
                                                    <b>Upload Nilai Peserta</b>
                                                </router-link>

                                                <!-- &nbsp;
                                                <button type="button" class="btn btn-info btn-md text-bold" @click="showModalUploadEvaluasiPelatihan()">
                                                    <i class="fa fa-upload"></i>
                                                &nbsp;
                                                Upload Evaluasi Pelatihan
                                                </button>                                 -->
                                                &nbsp;
                                                <router-link :to="`/data-pembelajaran/pra-pelaksanaan/detailUploadEvaluasiPelatihan/` + id" class="btn btn-info" v-if="user_role != 7 && user_role != 8">
                                                    <i class="fa fa-upload"></i>
                                                    &nbsp;
                                                    <b>Upload Evaluasi</b>
                                                </router-link>
                                                &nbsp;
                                                <router-link :to="`/data-pembelajaran/pra-pelaksanaan/detailRekapNilai/` + id" class="btn btn-info" v-if="user_role != 7 && user_role != 8">
                                                    <i class="fas fa-address-book"></i>
                                                    &nbsp;
                                                    <b>Rekap Nilai</b>
                                                </router-link>                                          
                                            </div>
                                        </div>

                                    </div>
                                </b-card>
                            </div>
                            <div class="col-12">
                                <b-card header-class="bg-transparent border-primary" class="border border-primary">
                                    <div class="card-body p-0">
                                        <b-tabs pills justified content-class="p-3 text-muted">
                                            <b-tab active class="border-0" v-if="user_role != 7 && user_role != 8">
                                                <template v-slot:title>
                                                    <span class="d-inline-block d-sm-none">
                                                        <i class="bx bx-user"></i>
                                                    </span>
                                                    <span class="d-none d-sm-inline-block">Peserta</span>
                                                </template>
                                                <div class="row">
                                                    <div class="col-2">
                                                        <div class="card-title mt-3">Data Peserta</div>
                                                    </div>
                                                    <div class="col-10">
                                                        <div class="d-flex justify-content-end">
                                                            <div class="btn-group">
                                                                <button type="button" class="btn btn-info btn-sm" @click="feedbackPeserta()">
                                                                    <i class="bx bx-check-square"></i> Feedback
                                                                    Peserta
                                                                </button>
                                                                <button type="button" class="btn btn-primary btn-sm" @click="formAbsensiPeserta()" :disabled="status_absensi_peserta == true
                                                                    ? false
                                                                    : true
                                                                    ">
                                                                    <i class="bx bx-check-square"></i> Absensi
                                                                    Peserta
                                                                </button>
                                                                <!-- <button v-if="status_konfirmasi_panitia == true" type="button" class="btn btn-success btn-sm" @click="konfirmasiPesertaLMS()">
                                  <i class="bx bx-check me-1"></i>
                                  Konfirmasi Peserta LMS
                                </button>
                                <button type="button" class="btn btn-warning btn-sm" @click="formTemplateSurat(1)">
                                  <i class="bx bx-envelope me-1"></i>
                                  Template Surat Pemanggilan Peserta
                                </button> -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <hr />
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="row">
                                                            <div class="col-6">
                                                                <div class="form-group">
                                                                    <label for="">Link WA Group</label>
                                                                    <input type="text" class="form-control" placeholder="Masukkan Link WA Group..." v-model="link_wa_grup" />
                                                                </div>
                                                            </div>
                                                            <div class="col-2">
                                                                <div class="form-group">
                                                                    <label for="">Kelas</label>
                                                                    <input type="text" class="form-control" placeholder="Masukkan Kelas..." v-model="pembelajaran_kelas" />
                                                                </div>
                                                            </div>
                                                            <div class="col-4">
                                                                <div style="margin-top: 26px !important">
                                                                    <button type="button" class="btn btn-success" @click="simpanLinkWAKelas()">
                                                                        <i class="bx bx-save"></i> Simpan
                                                                    </button>
                                                                    &nbsp;
                                                                    <!-- <button type="button" class="btn btn-info" @click="formUnggahUndangan('peserta')">
                                    <i class="bx bx-upload"></i> Unggah Undangan
                                  </button> -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <hr />
                                                    </div>
                                                    <div class="col-12">
                                                        <div class="row">
                                                            <!-- <div class="col-3">
                                <div class="form-group">
                                  <label for="">Jumlah Peserta Bersedia</label>
                                  <input type="text" class="form-control" disabled v-model="jumlah_peserta_bersedia" />
                                </div>
                              </div>
                              <div class="col-3">
                                <div class="form-group">
                                  <label for="">Jumlah Peserta Tidak Bersedia</label>
                                  <input type="text" class="form-control" disabled v-model="jumlah_peserta_tidak_bersedia" />
                                </div>
                              </div> -->
                                                            <div class="col-6">
                                                                <div style="margin-top: 26px !important">
                                                                    <button type="button" class="btn btn-warning" @click="formTambahPeserta()">
                                                                        <i class="fa fa-plus"></i> Tambah Peserta
                                                                    </button>
                                                                    &nbsp;
                                                                    <button type="button" class="btn btn-info" @click="showModalImport = true">
                                                                        <i class="fa fa-upload"></i> Import Peserta
                                                                    </button>
                                                                    &nbsp;
                                                                    <button type="button" class="btn btn-info" @click="exportPeserta()">
                                                                        <i class="fa fa-file-excel"></i> Export
                                                                        Peserta
                                                                    </button>
                                                                    &nbsp;
                                                                    <!-- <button v-if="
                                    status_button_verif_all_peserta == true
                                  " type="button" class="btn btn-primary" v-on:click="verifAll">
                                    <i class="mdi mdi-check-all me-1"></i>
                                    Verif Semua Peserta
                                  </button> -->
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <hr />
                                                        <div>
                                                            <div class="row">
                                                                <div class="col-12">
                                                                    <div class="col-md-12 mb-2">
                                                                        <div class="row">
                                                                            <div class="col-md-4">
                                                                                <table>
                                                                                    <tr>
                                                                                        <td>Show</td>
                                                                                        <td>
                                                                                            <select class="form-control form-control-sm" id="showpaginatetable" style="width: 100%" v-model="tableData.length" @change="getDataTablePeserta()">
                                                                                                <option value="10" selected>10</option>
                                                                                                <option value="50">50</option>
                                                                                                <option value="100">100</option>
                                                                                                <option value="200">200</option>
                                                                                                <option value="500">500</option>
                                                                                            </select>
                                                                                        </td>
                                                                                        <td>Entries</td>
                                                                                    </tr>
                                                                                </table>
                                                                            </div>
                                                                            <div class="col-md-5">&nbsp;</div>
                                                                            <div class="col-md-3">
                                                                                <input type="text" class="form-control form-control-sm" id="searchTable" placeholder="Cari Data ..." v-model="tableData.search" @input="searchDatatable" />
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <datatable :columns="columns" :sortKey="sortKey" :sortOrders="sortOrders" @sort="sortBy">
                                                                        <tbody>
                                                                            <tr v-if="peserta_pembelajaran == ''">
                                                                                <td class="text-center" colspan="30">
                                                                                    Data Tidak Tersedia
                                                                                </td>
                                                                            </tr>
                                                                            <tr v-else v-for="(
                                                                                row_data, key_data
                                                                                ) in peserta_pembelajaran" :key="key_data">
                                                                                <!-- <td class="text-center">
                                                                                    <div v-if="
                                                                                        row_data.status_peserta ==
                                                                                        'TERVERIFIKASI PANITIA' ||
                                                                                        row_data.status_peserta ==
                                                                                        'MENUNGGU KONFIRMASI'
                                                                                    ">
                                                                                        <b-form-checkbox v-bind:value="row_data.pls_id" v-model="multipleSend">
                                                                                        </b-form-checkbox>
                                                                                    </div>
                                                                                    <div v-else>-</div>
                                                                                </td> -->
                                                                                <td class="text-center">
                                                                                    <div v-if="
                                                                                        row_data.status_peserta ==
                                                                                        'BELUM TERVERIFIKASI' ||
                                                                                        row_data.status_peserta ==
                                                                                        'TERVERIFIKASI'
                                                                                    ">
                                                                                
                                                                                    </div>
                                                                                    <div v-else-if="
                                                                                        row_data.status_peserta ==
                                                                                        'TERVERIFIKASI PANITIA'
                                                                                    ">
                                  
                                                                                    </div>
                                                                                    <div v-else-if="
                                                                                        row_data.status_peserta ==
                                                                                        'MENUNGGU KONFIRMASI'
                                                                                    ">
                                                                                        <div class="d-grid gap-2 mt-1 mb-1">
                                                                                            <a role="button" class="btn btn-info btn-sm btn-block" v-bind:href="app_url +
                                                                                                'data-pembelajaran/confirm-kehadiran-peserta' +
                                                                                                '/' +
                                                                                                row_data.pls_pbl_id_encrypt +
                                                                                                '/' +
                                                                                                row_data.pls_id_peserta_encrypt
                                                                                                " target="_blank">
                                                                                                <i class="bx bx-link"></i> Link
                                                                                                Undangan
                                                                                            </a>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div v-else>
                                                                                        <div class="badge badge-pill badge-soft-success font-size-11 mt-1 mb-1">
                                                                                            CONFIRMED ({{
                                                                                                fullDateTimeFormat(
                                                                                                    row_data.updated_at
                                                                                                )
                                                                                            }})
                                                                                        </div>
                                                                                    </div>
                                                                                    <!-- <b-button variant="danger" size="sm" id="" class="my-1" @click="deletePeserta(row_data?.user?.user_id, row_data?.user?.name)"> -->
                                                                                    <b-button variant="danger" size="sm" id="" class="mb-1" @click="deletePeserta(row_data.pls_id, row_data?.user?.name)">
                                                                                        <i class="fas fa-trash"></i>
                                                                                        &nbsp;
                                                                                        <span><b>Hapus peserta</b></span>
                                                                                    </b-button>
                                                                                    &nbsp;
                                                                                    <router-link class="btn-sm btn btn-warning" :to="'/data-pembelajaran/pra-pelaksanaan/editPeserta/' + row_data?.user?.user_id + '/' + id">
                                                                                        <i class="fas fa-edit"></i>
                                                                                        &nbsp;
                                                                                        <b>Edit Peserta</b>
                                                                                    </router-link>
                                                                                    <!-- <b-button variant="warning" size="sm" id="" class="my-1" @click="editPeserta(row_data?.user?.user_id)"> 
                                                                                        <i class="fas fa-edit"></i>
                                                                                        &nbsp;
                                                                                        <span><b>Edit data</b></span>
                                                                                    </b-button> -->
                                                                                </td>
                                                                                <td class="text-center">
                                                                                    {{ key_data + 1 }}.
                                                                                </td>
                                                                                <td>
                                                                                    <div class="photoBox" style="cursor: pointer;">
                                                                                        <img
                                                                                            v-if="row_data?.user?.photo_exists == 'yes'"
                                                                                            style="width: 50px;" 
                                                                                            :src="domainPhoto + row_data?.user?.path_photo"
                                                                                            @click="showPhoto(row_data?.user?.path_photo, row_data?.user?.name)"
                                                                                        >
                                                                                        <img
                                                                                            v-else
                                                                                            style="width: 50px;" 
                                                                                            src="@/assets/images/users/avatar-9.png"
                                                                                        >
                                                                                    </div>
                                                                                </td>
                                                                                <td>{{ row_data?.user?.name }}</td>
                                                                                <td class="text-center">
                                                                                    {{ row_data?.user?.username }}
                                                                                </td>
                                                                                <td>{{ row_data?.user?.jenis_kelamin }}</td>
                                                                                <td>{{ row_data?.user?.agama }}</td>
                                                                                <td>{{ row_data?.user?.tanggal_lahir }}</td>
                                                                                <td>{{ row_data?.user?.email }}</td>
                                                                                <td>{{ row_data?.user?.mobile_phone }}</td>
                                                                                <td>{{ row_data?.user?.golongan }}</td>
                                                                                <td>{{ row_data?.user?.pangkat }}</td>
                                                                                <td>{{ row_data?.user?.jabatan_name }}</td>
                                                                                <td>{{ row_data?.user?.pendidikan_terakhir }}</td>
                                                                                <!-- <td>{{ row_data?.user?.pola_penyelenggaraan }}</td> -->
                                                                                <!-- <td>{{ row_data?.user?.sumber_anggaran }}</td> -->
                                                                                <td>{{ row_data?.user?.instansi }}</td>
                                                                                <td>{{ row_data?.user?.alamat_instansi }}</td>
                                                                                <td>{{ row_data?.user?.address }}</td>
                                                                                <td>{{ row_data?.user?.status_perkawinan }}</td>
                                                                                <td>{{ row_data?.user?.unit_eselon }}</td>
                                                                                <td>{{ row_data?.user?.telepon_fax }}</td>
                                                                                <!-- <td>{{ row_data?.user?.unit_organization }}</td> -->
                                                                                <!-- <td>{{ row_data.user.unit_name }}</td> -->
                                                                                <!-- <td class="text-center">
                                      <div v-if="
                                        row_data.status_peserta ==
                                        'BELUM TERVERIFIKASI'
                                      ">
                                        <div class="badge badge-pill badge-soft-danger font-size-11">
                                          BELUM TERVERIFIKASI
                                        </div>
                                      </div>
                                      <div v-else-if="
                                        row_data.status_peserta ==
                                        'TERVERIFIKASI'
                                      ">
                                        <div class="badge badge-pill badge-soft-success font-size-11">
                                          TERVERIFIKASI
                                        </div>
                                      </div>
                                      <div v-else-if="
                                        row_data.status_peserta ==
                                        'TERVERIFIKASI PANITIA'
                                      ">
                                        <div class="badge badge-pill badge-soft-info font-size-11">
                                          TERVERIFIKASI PANITIA
                                        </div>
                                      </div>
                                      <div v-else-if="
                                        row_data.status_peserta ==
                                        'MENUNGGU KONFIRMASI'
                                      ">
                                        <div class="badge badge-pill badge-soft-dark font-size-11">
                                          MENUNGGU KONFIRMASI
                                        </div>
                                      </div>
                                      <div v-else-if="
                                        row_data.status_peserta == 'BERSEDIA'
                                      ">
                                        <div class="badge badge-pill badge-soft-primary font-size-11">
                                          BERSEDIA
                                        </div>
                                      </div>
                                      <div v-else-if="
                                        row_data.status_peserta ==
                                        'TIDAK BERSEDIA'
                                      ">
                                        <div class="badge badge-pill badge-soft-warning font-size-11">
                                          TIDAK BERSEDIA
                                        </div>
                                      </div>
                                    </td> -->
                                                                                
                                                                            </tr>
                                                                        </tbody>
                                                                    </datatable>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <button v-if="multipleSend != ''" type="button" class="btn btn-success btn-sm mt-3" @click="kirimUndanganPesertaMultiple()">
                                                            <i class="bx bx-mail-send"></i> Kirim Undangan
                                                            Terpilih
                                                        </button>
                                                    </div>
                                                </div>
                                            </b-tab>
                                            <b-tab v-if="user_role != 7 && user_role != 8">
                                                <template v-slot:title>
                                                    <span class="d-inline-block d-sm-none">
                                                        <i class="far bx bx-user-check"></i>
                                                    </span>
                                                    <span class="d-none d-sm-inline-block">Widyaiswara</span>
                                                </template>
                                                <div class="row mt-3 mb-2">
                                                    <div class="col-6">
                                                        <div class="card-title">Data Widyaiswara</div>
                                                    </div>
                                                    <div class="col-6">
                                                        <div class="d-flex justify-content-end">
                                                            <button v-if="status_laporan == 'NOT READY'" type="button" class="btn btn-success btn-sm" @click="confirmStatus('laporan')" :disabled="status_instruktur == 'READY' ? false : true
                                                                ">
                                                                <i class="bx bx-check me-1"></i>
                                                                Sudah Input Nilai di LMS
                                                            </button>
                                                            <button v-else type="button" class="btn btn-success btn-sm">
                                                                <i class="bx bx-check me-1"></i>
                                                                Input Nilai LMS
                                                            </button>
                                                            &nbsp;
                                                            <button type="button" class="btn btn-primary btn-sm" v-on:click="formAbsensiInstruktur" @click="formAbsensiInstruktur()" :disabled="status_instruktur == 'READY' ? false : true
                                                                ">
                                                                <i class="bx bx-check-square me-1"></i>
                                                                Absensi Instruktur
                                                            </button>
                                                            &nbsp;
                                                            <button type="button" class="btn btn-info btn-sm" @click="formUnggahUndangan('instruktur')">
                                                                <i class="bx bx-upload"></i> Unggah Undangan
                                                            </button>
                                                            &nbsp;
                                                            <button type="button" class="btn btn-warning btn-sm" @click="formTemplateSurat(2)">
                                                                <i class="bx bx-envelope me-1"></i>
                                                                Template Surat Pemanggilan Instruktur
                                                            </button>
                                                            &nbsp;
                                                            <button type="button" class="btn btn-success btn-sm" v-on:click="formTambahInstruktur">
                                                                <i class="mdi mdi-plus me-1"></i>
                                                                Tambah Instruktur
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <b-alert v-if="instrukturDuplikat != ''" dismissible show variant="warning">
                                                    <i class="mdi mdi-alert-outline me-2"></i>
                                                    <span>Terdapat
                                                        <b>{{ instrukturDuplikat.length }} duplikat data</b></span>
                                                    <ul>
                                                        <li v-for="(row_data, key_data) in instrukturDuplikat" :key="key_data">
                                                            {{ row_data.nipName }}
                                                        </li>
                                                    </ul>
                                                </b-alert>
                                                <table-instruktur v-if="showTableInstruktur" @refresh-table="refreshTableInstruktur" :idPembelajaran="id" :durasiPembelajaran="durasi_jp"></table-instruktur>
                                            </b-tab>
                                            <b-tab>
                                                <template v-slot:title>
                                                    <span class="d-inline-block d-sm-none">
                                                        <i class="bx bx-user"></i>
                                                    </span>
                                                    <span class="d-none d-sm-inline-block">Tahapan Diklat</span>
                                                </template>
                                                <div class="row mt-3 mb-2">
                                                    <div class="col-5">
                                                        <div class="card-title">Data Tahapan Diklat</div>
                                                    </div>

                                                    <div class="col-7 text-end d-flex justify-content-end gap-2">
                                                        <b-button
                                                            size="sm" 
                                                            variant="success" 
                                                            @click="showModal.importTahapan = true"
                                                        >
                                                            <i class="fas fa-file-excel"></i>
                                                            &nbsp;
                                                            <b>Import Tahapan Diklat</b>
                                                        </b-button>
                                                        
                                                        <b-button size="sm" variant="primary" @click="exportTahapanDiklat()">
                                                            Export Excel
                                                        </b-button>

                                                        
                                                        <!-- Tombol untuk mengekspor PDF -->
                                                        <b-button size="sm" variant="primary" @click="exportTahapanDiklatToPDF()">
                                                        Export PDF
                                                        </b-button>


                                                        <b-button size="sm" variant="success" @click="setupStagesAdd()" v-if="user_role != 7 && user_role != 8">
                                                            <i class="fas fa-plus"></i>
                                                            Tambah Tahapan
                                                        </b-button>
                                                    </div>
                                                </div>

                                                <div class="row mt-3 mb-2">
                                                    <table-tahapan-diklat v-if="showTableDiklat == true" :mkp_kode_pembelajaran="kode" :mkp_judul="judul" :idPembelajaran="id" :key="keyTahapanDiklat"></table-tahapan-diklat>
                                                </div>
                                            </b-tab>
                                            <b-tab v-if="user_role != 7 && user_role != 8">
                                                <template v-slot:title>
                                                    <span class="d-inline-block d-sm-none">
                                                        <i class="bx bx-clipboard"></i>
                                                    </span>
                                                    <span class="d-none d-sm-inline-block">Dokumentasi</span>
                                                </template>
                                                <div class="row mt-3 mb-2">
                                                    <div class="col-6">
                                                        <div class="card-title">Data Dokumentasi</div>
                                                    </div>
                                                    <div class="col-6">
                                                        <div class="d-flex justify-content-end">
                                                            <button type="button" class="btn btn-success btn-sm" @click="showModalAddDokumentasi()">
                                                                <i class="mdi mdi-plus me-1"></i>
                                                                Tambah Dokumentasi
                                                            </button>

                                                            <!-- <button type="button" class="btn btn-success btn-sm" @click="formTambahMateri">
                                                                <i class="mdi mdi-plus me-1"></i>
                                                                Tambah Dokumentasi Ori
                                                            </button> -->
                                                        </div>
                                                    </div>
                                                </div>
                                                <b-alert v-if="materiDuplikat != ''" dismissible show variant="warning">
                                                    <i class="mdi mdi-alert-outline me-2"></i>
                                                    <span>Terdapat
                                                        <b>{{ materiDuplikat.length }} duplikat data</b></span>
                                                    <ul>
                                                        <li v-for="(row_data, key_data) in materiDuplikat" :key="key_data">
                                                            {{ row_data.materi }}
                                                        </li>
                                                    </ul>
                                                </b-alert>

                                                <div class="table-responsive pb-3">
                                                    <table class="table mb-0 mt-0 table-bordered table-condensed table-hover" style="width: 100%;">
                                                        <thead>
                                                            <tr class="align-middle text-center">
                                                                <th style="width: 7vw;"><b>No</b></th>
                                                                <th style="min-width:25vw; width: auto;"><b>Nama</b></th>
                                                                <th style="min-width:20vw;"><b>Link</b></th>
                                                                <th style="min-width:10vw;"><b>Kategori</b></th>
                                                                <th style="min-width:35vw;"><b>Deskripsi</b></th>
                                                                <th style="min-width:20vw; width: auto;"><b>Aksi</b></th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-if="loadingTable.dokumentasi == true">
                                                                <td colspan="30" class="text-center">
                                                                    <i class="fas fa-spin fa-spinner"></i> loading . . .
                                                                </td>
                                                            </tr>
                                                            <tr v-else-if="dataTableDokumentasi == ''">
                                                                <td colspan="30" class="text-center">-- Data kosong --</td>
                                                            </tr>
                                                            <tr v-else v-for="(rowData, keyData) in dataTableDokumentasi" :key="keyData">
                                                                <td class="text-center">{{ keyData + 1 }}</td>
                                                                <td>{{ rowData.lm_name }}</td>
                                                                <td>{{ rowData.lm_link }}</td>
                                                                <td class="text-center">{{ rowData.remark }}</td>
                                                                <td>{{ rowData.lm_description }}</td>
                                                                <td class="text-center">
                                                                    <div class="btn-group" role="group">
                                                                        <b-button variant="info" @click="openFileDokumentasi(rowData.materi_pembelajaran_dokumen.lmd_path_file)" size="sm" style="white-space: nowrap;">
                                                                            <i class="fas fa-file"></i>
                                                                            &nbsp;
                                                                            <span><b>Download Dokumen</b></span>
                                                                        </b-button>
                                                                        <b-button variant="warning" @click="editDocumentation(rowData.lm_id, rowData.pbl_id)" size="sm" style="white-space: nowrap;">
                                                                            <i class="fas fa-edit"></i>
                                                                            &nbsp;
                                                                            <span><b>Edit</b></span>
                                                                        </b-button>
                                                                        <b-button variant="danger" @click="deleteDocumentation(rowData.lm_id)" size="sm" style="white-space: nowrap;">
                                                                            <i class="fas fa-trash"></i>
                                                                            &nbsp;
                                                                            <span><b>Hapus</b></span>
                                                                        </b-button>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>

                                                <!-- <table-materi v-if="showTableMateri" @refresh-table="refreshTableMateri" @form-edit-materi="formEditMateri" :idPembelajaran="id"></table-materi> -->
                                            </b-tab>
                                            <b-tab v-if="user_role != 7 && user_role != 8 && pratikum != 'Tidak'">
                                                <template v-slot:title>
                                                    <span class="d-inline-block d-sm-none">
                                                        <i class="bx bxs-flask"></i>
                                                    </span>
                                                    <span class="d-none d-sm-inline-block">Praktikum</span>
                                                </template>
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="row">
                                                            <div class="col-2">
                                                                <div class="card-title mb-2">
                                                                    Data Praktikum
                                                                </div>
                                                            </div>
                                                            <div class="col-10">
                                                                <div class="d-flex justify-content-end">
                                                                    <div v-if="pratikum == 'Ya'">
                                                                        <button type="button" class="btn btn-success btn-sm" @click="formTambahPraktikum">
                                                                            <i class="mdi mdi-plus me-1"></i>
                                                                            Tambah Praktikum
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-12">
                                                        <hr />
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-12">
                                                        <table-praktikum v-if="showTablePraktikum" @refresh-table="refreshTablePraktikum" @form-detail-praktikum="formDetailPraktikum" :idPembelajaran="id"></table-praktikum>
                                                    </div>
                                                </div>
                                            </b-tab>
                                            <!-- <b-tab v-if="user_role != 7 && user_role != 8"> -->
                                                <!-- <template v-slot:title>
                                                    <span class="d-inline-block d-sm-none">
                                                        <i class="bx bx-briefcase-alt-2"></i>
                                                    </span>
                                                    <span class="d-none d-sm-inline-block">Akomodasi</span>
                                                </template> -->
                                                <!-- <div class="row mt-3 mb-2">
                                                    <div class="col-6">
                                                        <div class="card-title">
                                                            Data Akomodasi
                                                            <span class="badge badge-pill badge-soft-success">Updated at:
                                                                {{
                                                                    akomodasi_generate_at
                                                                        ? fullDateTimeFormat(akomodasi_generate_at)
                                                                        : "-"
                                                                }}</span>
                                                        </div>
                                                    </div>
                                                    <div class="col-6">
                                                        <div class="d-flex justify-content-end">
                                                            <button type="button" class="btn btn-info btn-sm me-1" @click="checkKamar()">
                                                                <i class="mdi mdi-bed me-1"></i>
                                                                Cek Kamar
                                                            </button>
                                                            <button type="button" class="btn btn-success btn-sm" @click="genAkomodasi()">
                                                                <i class="fa fa-redo me-1"></i>
                                                                Generate Akomodasi
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <b-alert v-if="akomodasiDuplikat != ''" dismissible show variant="warning">
                                                    <i class="mdi mdi-alert-outline me-2"></i>
                                                    <span>Terdapat
                                                        <b>{{ akomodasiDuplikat.length }} duplikat data</b></span>
                                                    <ul>
                                                        <li v-for="(row_data, key_data) in akomodasiDuplikat" :key="key_data">
                                                            {{ row_data.akomodasi }}
                                                        </li>
                                                    </ul>
                                                </b-alert>
                                                <table-akomodasi v-if="showTableAkomodasi" :strategiModel="strategi_model" :pblOnline="pbl_online" :pblOffline="pbl_offline" :totBudgetPlan="tot_budget_plan" :totBudgetConfirm="tot_budget_confirm" :totBudgetFix="tot_budget_fix" :durasiHE="durasi_he" @refresh-table="refreshTableAkomodasi" @update-pbl-onl-off="updatePblOnlOff" :idPembelajaran="id"></table-akomodasi>
                                            </b-tab> -->
                                        </b-tabs>
                                    </div>
                                </b-card>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <b-modal v-model="showModal.importTahapan" title="Import Tahapan Diklat" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <form-import-tahapan v-if="showModal.importTahapan" @refreshTable="refreshTableDiklat" @closeModal="closeModalImportTahapan" :idPembelajaran="id"></form-import-tahapan>
        </b-modal>

        <!-- Popup Form Tambah Data Peserta -->
        <b-modal v-model="showFormAddPeserta" title="Form Tambah Peserta" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <form-add-peserta v-if="showFormAddPeserta" :idPembelajaran="id"></form-add-peserta>
        </b-modal>

        <!-- Popup Form Tambah Data Instruktur -->
        <b-modal v-model="showFormAddInstruktur" title="Form Tambah Instruktur" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <form-add-instruktur v-if="showFormAddInstruktur" @refresh-table="refreshTableInstruktur" :idPembelajaran="id"></form-add-instruktur>
        </b-modal>

        <!-- Popup Form Tambah Data Pratikum -->
        <b-modal v-model="showFormAddPraktikum" title="Form Tambah Praktikum" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <form-add-praktikum v-if="showFormAddPraktikum" @refresh-table="refreshTablePraktikum" :idPembelajaran="id"></form-add-praktikum>
        </b-modal>

        <!-- Popup Form Tambah Data Materi -->
        <b-modal v-model="showFormAddMateri" title="Form Tambah Materi" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <form-add-materi v-if="showFormAddMateri" @refresh-table="refreshTableMateri" :idPembelajaran="id"></form-add-materi>
        </b-modal>

        <!-- Popup Form Edit Data Materi -->
        <b-modal v-model="showFormEditMateri" title="Form Ubah Materi Master" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <form-edit-materi v-if="showFormEditMateri" @refresh-table="refreshTableMateri" :idData="idMateri"></form-edit-materi>
        </b-modal>

        <!-- Popup Form Tambah Data Akomodasi -->
        <b-modal v-model="showFormAddAkomodasi" title="Form Tambah Akomodasi" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <form-add-akomodasi v-if="showFormAddAkomodasi" @refresh-table="refreshTableAkomodasi" :idPembelajaran="id" :strategiId="strategi_id"></form-add-akomodasi>
        </b-modal>

        <!-- Popup Form Detail Praktikum -->
        <b-modal v-model="showFormDetailPraktikum" title="Detail Praktikum" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <detail-praktikum v-if="showFormDetailPraktikum" @refresh-table="refreshTablePraktikum" :idPraktikum="idPraktikumSelected" :idPembelajaran="id"></detail-praktikum>
        </b-modal>

        <!-- Popup Form Unggah Undangan Peserta -->
        <b-modal v-model="showFormUnggahUndangan" title="Formulir Unggah Undangan Peserta" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <form-unggah-undangan v-if="showFormUnggahUndangan" @close-form-undangan="closeFormUndangan" :statusUnggahUndangan="status_unggah_undangan" :idPembelajaran="id"></form-unggah-undangan>
        </b-modal>

        <!-- Popup Form Absensi Peserta -->
        <b-modal v-model="showFormAbsensiPeserta" title="Absensi Peserta" title-class="text-black font-18" body-class="p-3" size="xl" hide-footer>
            <absensi-peserta v-if="showFormAbsensiPeserta" @close-form-absensi-peserta="closeFormAbsensiPeserta" :idPembelajaran="id"></absensi-peserta>
        </b-modal>

        <!-- Popup Form Absensi Instruktur -->
        <b-modal v-model="showFormAbsensiInstruktur" title="Absensi Instruktur" title-class="text-black font-18" body-class="p-3" size="xl" hide-footer>
            <absensi-instruktur v-if="showFormAbsensiInstruktur" @close-form-absensi-instruktur="closeFormAbsensiInstruktur" :idPembelajaran="id"></absensi-instruktur>
        </b-modal>

        <!-- Popup Form Absensi Instruktur -->
        <b-modal v-model="showFormTemplateSurat" title="Template Surat Pemanggilan" title-class="text-black font-18" body-class="p-3" size="xl" hide-footer>
            <template-surat-pemanggilan v-if="showFormTemplateSurat" :idPembelajaran="id" :strategiId="strategi_id" :tipeSurat="tipeSuratPemanggilan"></template-surat-pemanggilan>
        </b-modal>

        <!-- Popup Feedback Peserta -->
        <b-modal v-model="showFeedbackPeserta" title="Feedback Peserta" title-class="text-black font-18" body-class="p-3" size="xl" hide-footer>
            <b-form class="p-2" @submit.prevent="updateFeedback">
                <div class="form-group">
                    <label for="">Isi</label>
                    <textarea name="" class="form-control" v-model="feedback_peserta_temp" id="" cols="30" rows="10"></textarea>
                </div>
                <hr />
                <div class="row">
                    <div class="col text-end">
                        <button type="submit" class="btn btn-success">Simpan</button>
                    </div>
                </div>
            </b-form>
        </b-modal>
        <!-- Popup List Kamar -->
        <b-modal v-model="showKamar" title="List Kamar" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
            <room-akomodasi v-if="showFormKamar" :idPembelajaran="id"></room-akomodasi>
        </b-modal>
    </Layout>

    <b-modal v-model="setupModalAdd" id="modal-2" hide-footer title="Tambah Tahapan" size="lg" @hidden="closeModalStagesAdd">
        <b-form-group label="Pilih Tahapan" label-for="selectStagesAdd">
            <select class="form-select mb-3" id="selectStagesAdd" v-model="selectStageAdd" @change.prevent="selectStagesAdd()" :disabled="selectStageDisabled">
                <option value="">-- Pilih Tahapan --</option>
                <option v-for="(row, index) in listOptSelectStage" :value="row.value" :key="index">{{ row.value }}</option>
            </select>
        </b-form-group>
      

        <b-form @submit.prevent="storeDataStages">
            <template v-if="selectStageAdd == ''">
                <div class="row">
                    <div class="col-md-12">
                        <h5 class="text-center">-- Pilih Tahapan Terlebih Dahulu --</h5>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="container-fluid" style="background: #e9ebf7; border-radius: 10px; padding: 10px 8px;">
                    <div class="row">
                        <div class="col-md-12">
                            <b-form-group class="mb-3" label="Judul Materi" label-for="titleMateriAdd">
                                <b-form-input id="titleMateriAdd" placeholder="Masukkan Judul Materi..." type="text" v-model="titleMateriAdd">
                                </b-form-input>
                            </b-form-group>

                            <b-form-group class="mb-3" label="Tanggal Pelaksanaan" label-for="dateAgendaAdd">
                                <b-form-input id="dateAgendaAdd" v-model="dateAgendaAdd" type="date">
                                </b-form-input>
                            </b-form-group>

                            <b-form-group class="mb-3" label="Jumlah JP" label-for="durationAgendaAdd">
                                <b-form-input id="durationAgendaAdd" v-model="durationAgendaAdd" placeholder="Masukkan Jumlah Jam Pembelajaran..." type="number">
                                </b-form-input>
                            </b-form-group>

                            <div class="row">
                                <div class="col-6">
                                    <b-form-group class="mb-3" label="Jam Dimulai" label-for="durationStartAdd">
                                        <b-form-input id="durationStartAdd" v-model="durationStartAdd" type="time" step="1800" placeholder="HH:MM" pattern="^([01]\d|2[0-3]):([0-5]\d)$">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                                <div class="col-6">
                                    <b-form-group class="mb-3" label="Jam Selesai" label-for="durationEndAdd">
                                        <b-form-input id="durationEndAdd" v-model="durationEndAdd" type="time">
                                        </b-form-input>
                                    </b-form-group>
                                </div>
                            </div>

                            <b-form-group class="mb-3" label="Kelompok" label-for="selectGroupAdd">
                                <select class="form-select mb-3" id="selectGroupAdd" v-model="selectGroupAdd">
                                    <option value="">-- Pilih Kelompok --</option>
                                    <option value="1">I</option>
                                    <option value="2">II</option>
                                    <option value="3">III</option>
                                    <option value="4">IV</option>
                                    <option value="5">Kelompok Gabungan</option>
                                </select>
                            </b-form-group>

                            <b-form-group class="mb-3" label="Keterangan" label-for="detailAgendaAdd">
                                <textarea class="form-control" id="detailAgendaAdd" v-model="detailAgendaAdd" placeholder="Keterangan Agenda . . ." cols="30" rows="7" style="resize:none;"></textarea>
                            </b-form-group>

<!-- cari instruktur -->
<b-form-group class="mb-3" label="Instruktur" label-for="kelompokInstrukturAdd">
      <div class="row">
        <div class="col-12">
          <table class="table mb-0 mt-0 table-bordered table-condensed table-hover">
            <thead class="bg-dark text-center text-white">
              <tr>
                <th style="width: 50px">No</th>
                <th style="width: auto">Instruktur</th>
                <th style="width: 35%">Kelompok</th>
                <th style="width: 50px" class="text-center">
                  <b-button
                    type="button"
                    class="btn btn-success btn-sm"
                    @click="addRowPeserta"
                  >
                    <i class="fa fa-plus"></i>
                  </b-button>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row_data, key_data) in instruktur_data" :key="key_data">
                <td class="text-center">{{ key_data + 1 }}.</td>
                <td>
                  <v-select
                    label="nip_name"
                    v-model="row_data.data_instruktur"
                    :options="peserta_ref"
                    @search="onSearchInstruktur"
                    placeholder="Cari dan Pilih Instruktur..."
                  ></v-select>
                </td>
                <td>
                  <b-form-input
                  name="kelompok_instruktur"
                    placeholder="Masukkan Kelompok..."
                    v-model="row_data.titleKelompokAdd"
                  ></b-form-input>

    

                </td>
                <td class="text-center">
                  <button
                    type="button"
                    class="btn btn-danger btn-sm"
                    @click="deleteRow(key_data, row_data)"
                  >
                    <i class="fa fa-minus"></i>
                  </button>
                </td>
              </tr>
            </tbody>
        </table>
        </div>
      </div>
</b-form-group>                          


<!-- <b-form-group>
    <form-add-instruktur-kelompok
        @senddata="testsendparent"
    />
</b-form-group> -->

                            <b-form-group class="mb-3" label="Link Zoom" label-for="linkAgendaAdd">
                                <b-form-input id="linkAgendaAdd" v-model="linkAgendaAdd" placeholder="http://. . . . ." type="url">
                                </b-form-input>
                            </b-form-group>

                            <b-form-group class="mb-3" label="Link File" label-for="linkFileAdd">
                                <b-form-input id="linkFileAdd" v-model="linkFileAdd" placeholder="http://. . . . ." type="url">
                                </b-form-input>
                            </b-form-group>

                            <b-form-group class="mb-3" label="Link Materi" label-for="linkVideoAdd">
                                <b-form-input id="linkVideoAdd" v-model="linkVideoAdd" placeholder="http://. . . . ." type="url">
                                </b-form-input>
                            </b-form-group>

                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="formPpt" class="form-label">Pilih File PPT</label>
                                    <input
                                    class="form-control"
                                    name="uploadFilePpt"
                                    type="file"
                                    id="formPpt"
                                    v-on:change="uploadFilePptt($event)"
                                    />
                                    <div class="respond-input-file float-left" id="uploadLoadingPpt"></div>
                                    <small class="float-right" style="color: red">
                                    *) Max File 2 MB & File Wajib PPT
                                    </small>
                                </div>
                                </div>

                            <div class="col-12">
                                <div class="mb-3">
                                    <label for="formPdf" class="form-label">Pilih File PDF</label>
                                    <input
                                    class="form-control"
                                    name="uploadFilePdf"
                                    type="file"
                                    id="formPdf"
                                    v-on:change="uploadFilePdff($event)"
                                    />
                                    <div class="respond-input-file float-left" id="uploadLoadingPdf"></div>
                                    <small class="float-right" style="color: red">
                                    *) Max File 2 MB & File Wajib PDF
                                    </small>
                                </div>
                                </div>

                            <div class="row">
                                <div class="col-6 mt-2">
                                    <b-form-group label="Apakah upload tugas ?">
                                        <div>
                                            <b-form-radio class="d-inline-block" v-model="questionUploadAdd" name="questionUploadAdd" value="yes">
                                                Yes
                                            </b-form-radio>
                                            &nbsp;
                                            <b-form-radio class="d-inline-block" v-model="questionUploadAdd" name="questionUploadAdd" value="no">
                                                No
                                            </b-form-radio>
                                        </div>
                                    </b-form-group>
                                </div>

                                <div class="col-6">
                                    <b-form-group label="Apakah online meeting ?">
                                        <div>
                                            <b-form-radio class="d-inline-block" v-model="questionOnlineMeetingAdd" name="questionOnlineMeetingAdd" value="yes">
                                                Yes
                                            </b-form-radio>
                                            &nbsp;
                                            <b-form-radio class="d-inline-block" v-model="questionOnlineMeetingAdd" name="questionOnlineMeetingAdd" value="no">
                                                No
                                            </b-form-radio>
                                        </div>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <hr style="background:grey; height: 2px; border-radius: 25%;">
                        </div>
                        <div class="col-md-12 text-end">
                            <b-button type="reset" variant="danger" @click.prevent="confirmResetFormStagesAdd()">
                                <i class="fas fa-redo-alt"></i> <b>Reset</b>
                            </b-button>
                            &nbsp;
                            <b-button type="sumbit" variant="success">
                                <i class="fas fa-check"></i> <b>Simpan</b>
                            </b-button>
                        </div>
                    </div>
                </div>
            </template>
        </b-form>
    </b-modal>

    <b-modal v-model="showModal.addDokumentasi" title="Tambah Dokumentasi" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer @hidden="clearFormAddDokumentasi()">
        <b-form @submit.prevent="storeDataAddDokumentasi()">
            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Nama File" label-for="namaFile">
                        <b-form-input id="namaFile" placeholder="Masukkan Nama File..." type="text" v-model="dataDokumentasi.lm_name"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Link Dokumentasi" label-for="linkDokumentasi">
                        <b-form-input id="linkDokumentasi" placeholder="Link Dokumentasi..." type="url" v-model="dataDokumentasi.lm_link"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Kategori Dokumentasi" label-for="selectCategory">
                        <select class="form-select mb-3" id="selectCategory" v-model="dataDokumentasi.remark" :disabled="selectKategoriDokumentasiDisabled">
                            <option value="">-- Pilih Kategori --</option>
                            <option v-for="(rowData, keyData) in listOptKategoriDokumentasi" :value="rowData.value" :key="keyData">{{ rowData.value }}</option>
                        </select>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <label for="formPhoto" class="form-label">Pilih File</label>
                    <input type="file" class="form-control" id="formPhoto" v-on:change="inputFilePhoto()">
                    <div class="respond-input-file float-left" id="uploadLoading"></div>
                    <small class="float-right" style="color: red">* Max File 5 MB</small>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Deskripsi" label-for="deskripsiFile">
                        <textarea class="form-control" id="deskripsiFile" v-model="dataDokumentasi.lm_description" placeholder="Deskripsi . . ." cols="30" rows="7" style="resize:none;"></textarea>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 text-end">
                    <b-button variant="success" type="submit">
                        <i class="fas fa-check"></i>
                        &nbsp;
                        <b>Simpan</b>
                    </b-button>
                </div>
            </div>
        </b-form>
    </b-modal>

    <b-modal v-model="showModal.editDokumentasi" title="Edit Dokumentasi" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer @hidden="clearFormAddDokumentasi()">
        <b-form @submit.prevent="storeDataEditDokumentasi()">
            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Nama File" label-for="namaFile">
                        <b-form-input id="namaFile" placeholder="Masukkan Nama File..." type="text" v-model="dataEdit.lm_name"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Link Dokumentasi" label-for="linkDokumentasi">
                        <b-form-input id="linkDokumentasi" placeholder="Link Dokumentasi..." type="url" v-model="dataEdit.lm_link"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Kategori Dokumentasi" label-for="selectCategory">
                        <select class="form-select mb-3" id="selectCategory" v-model="dataEdit.remark" :disabled="selectKategoriDokumentasiDisabled">
                            <option value="">-- Pilih Kategori --</option>
                            <option v-for="(rowData, keyData) in listOptKategoriDokumentasi" :value="rowData.value" :key="keyData">{{ rowData.value }}</option>
                        </select>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <label for="formPhotoEdit" class="form-label">Pilih File</label>
                    <input type="file" class="form-control" id="formPhotoEdit" v-on:change="inputFileEditPhoto()">
                    <div class="respond-input-file float-left" id="uploadLoadingEdit"></div>
                    <small class="float-right" style="color: red">* Max File 5 MB</small>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Deskripsi" label-for="deskripsiFile">
                        <textarea class="form-control" id="deskripsiFile" v-model="dataEdit.lm_description" placeholder="Deskripsi . . ." cols="30" rows="7" style="resize:none;"></textarea>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 text-end">
                    <b-button variant="success" type="submit">
                        <i class="fas fa-check"></i>
                        &nbsp;
                        <b>Simpan</b>
                    </b-button>
                </div>
            </div>
        </b-form>
    </b-modal>

    <b-modal v-model="showModalImport" title="Import Peserta" title-class="text-black font-18" body-class="p-3" hide-footer>
        <div class="col-12">
            <div class="mb-3">
                <button class="btn btn-sm btn-success" @click="downloadFile">
                    <i class="dripicons-article"> </i>
                    Download Template
                </button>
            </div>
        </div>
        <b-form class="p-2" @submit.prevent="ImportData">
            <div class="row">
                <div class="col-12">
                    <div class="mb-3">
                        <label for="Kode">Import File Excel</label>
                        <input class="form-control" type="file" id="importexcel" @change="uploadFile" />
                    </div>
                    <div class="respond-input-file float-left" id="uploadLoadingExcel"></div>
                </div>
            </div>
            <div class="text-end pt-5 mt-3">
                <b-button variant="light" @click="showModalImport = false">Close</b-button>
                <b-button type="submit" variant="success" class="ms-1">
                    <i class="bx bx-save"></i>
                    Save
                </b-button>
            </div>
        </b-form>
    </b-modal>

    <b-modal v-model="showModal.editPeserta" title="Edit Peserta" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer>
        <b-form class="p-2" @submit.prevent="storePeserta">
            <div class="row">
                <div class="col-24">
                    <div class="mb-3">
                        <table class="table mb-0 mt-0 table-bordered table-condensed table-hover" style="text-align: center;">
                            <thead class="bg-dark text-center text-white">
                                <th style="width: 200px">Nama</th>
                                <th style="width: 200px">NIP</th>
                                <th style="width: 200px">Jabatan Lama</th>
                                <th style="width: 200px">Unit Lama</th>
                            </thead>
                            <tbody>
                                <td class="align-middle"> {{ dataPesertaEdit.name }} </td>
                                <td class="align-middle"> {{ dataPesertaEdit.nip }} </td>
                                <td class="align-middle">
                                    <input type="text" class="form-control bg-light border-dark" v-model= "dataPesertaEdit.jabatan_lama" />
                                </td>
                                <td class="align-middle">
                                    <input type="text" class="form-control bg-light border-dark" v-model=" dataPesertaEdit.unit_lama "/>
                                </td>
                            </tbody>
                        </table>
                    </div>
                    <div class="respond-input-file float-left" id="uploadLoadingExcel"></div>
                </div>
            </div>
            <div class="text-end pt-5 mt-3">
                <b-button variant="light" @click="showModal.editPeserta = false">Close</b-button>
                <b-button type="submit" variant="success" class="ms-1">
                    <i class="bx bx-save"></i>
                    Save
                </b-button>
            </div>
        </b-form>
    </b-modal>

    <b-modal v-model="showModal.uploadNilaiPeserta" title="Upload Nilai Peserta" title-class="text-black font-18" body-class="p-3" size="lg" @hidden="clearFormuploadNilaiPeserta()">
        <b-form @submit.prevent="storeDataUploadNilaiPeserta()">
            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Nama File 1" label-for="namaFile1">
                        <b-form-input id="namaFile1" placeholder="Masukkan Nama File..." type="text" v-model="dataUploadNilaiPeserta.namafilenilai1"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Link Dokumentasi 1" label-for="linkDokumentasi">
                        <b-form-input id="linkDokumentasi" placeholder="Link Dokumentasi..." type="url" v-model="dataUploadNilaiPeserta.linknilai1"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
            <div class="col-md-12">
                <label for="formPhoto1" class="form-label">Upload File 1</label>
                <input type="file" class="form-control" id="formPhoto1" v-on:change="inputFilePhoto1()">
                <div class="respond-input-file float-left" id="uploadLoading1"></div>
                <small class="float-right" style="color: red">* Max File 5 MB</small>
            </div>
            </div>


            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Nama File 2" label-for="namaFile2">
                        <b-form-input id="namaFile2" placeholder="Masukkan Nama File..." type="text" v-model="dataUploadNilaiPeserta.namafilenilai2"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Link Dokumentasi 2" label-for="linkDokumentasi">
                        <b-form-input id="linkDokumentasi" placeholder="Link Dokumentasi..." type="url" v-model="dataUploadNilaiPeserta.linknilai2"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <label for="formPhoto2" class="form-label">Upload File 2</label>
                    <input type="file" class="form-control" id="formPhoto2" v-on:change="inputFilePhoto2()">
                    <div class="respond-input-file float-left" id="uploadLoading2"></div>
                    <small class="float-right" style="color: red">* Max File 5 MB</small>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Nama File 3" label-for="namaFile1">
                        <b-form-input id="namaFile1" placeholder="Masukkan Nama File..." type="text" v-model="dataUploadNilaiPeserta.namafilenilai3"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Link Dokumentasi 3" label-for="linkDokumentasi">
                        <b-form-input id="linkDokumentasi" placeholder="Link Dokumentasi..." type="url" v-model="dataUploadNilaiPeserta.linknilai3"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <label for="formPhoto3" class="form-label">Upload File 3</label>
                    <input type="file" class="form-control" id="formPhoto3" v-on:change="inputFilePhoto3()">
                    <div class="respond-input-file float-left" id="uploadLoading3"></div>
                    <small class="float-right" style="color: red">* Max File 5 MB</small>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 text-end">
                    <b-button variant="success" type="submit">
                        <i class="fas fa-check"></i>
                        &nbsp;
                        <b>Simpan</b>
                    </b-button>
                </div>
            </div>
        </b-form>
    </b-modal>

    <b-modal v-model="showModal.uploadEvaluasiPelatihan" title="Upload Nilai Peserta" title-class="text-black font-18" body-class="p-3" size="lg" hide-footer @hidden="clearFormuploadEvaluasiPelatihan()">
        <b-form @submit.prevent="storeDataUploadEvaluasiPelatihan()">
            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Nama File 1" label-for="namaFile1">
                        <b-form-input id="namaFile1" placeholder="Masukkan Nama File..." type="text" v-model="dataUploadEvaluasiPelatihan.namafilenilai1"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Link Dokumentasi 1" label-for="linkDokumentasi">
                        <b-form-input id="linkDokumentasi" placeholder="Link Dokumentasi..." type="url" v-model="dataUploadEvaluasiPelatihan.linknilai1"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
            <div class="col-md-12">
                <label for="formPhoto4" class="form-label">Upload File 1</label>
                <input type="file" class="form-control" id="formPhoto4" v-on:change="inputFilePhotoEvaluasi1()">
                <div class="respond-input-file float-left" id="uploadLoading4"></div>
                <small class="float-right" style="color: red">* Max File 5 MB</small>
            </div>
            </div>


            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Nama File 2" label-for="namaFile2">
                        <b-form-input id="namaFile2" placeholder="Masukkan Nama File..." type="text" v-model="dataUploadEvaluasiPelatihan.namafilenilai2"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Link Dokumentasi 2" label-for="linkDokumentasi">
                        <b-form-input id="linkDokumentasi" placeholder="Link Dokumentasi..." type="url" v-model="dataUploadEvaluasiPelatihan.linknilai2"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <label for="formPhoto5" class="form-label">Upload File 2</label>
                    <input type="file" class="form-control" id="formPhoto5" v-on:change="inputFilePhotoEvaluasi2()">
                    <div class="respond-input-file float-left" id="uploadLoading5"></div>
                    <small class="float-right" style="color: red">* Max File 5 MB</small>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Nama File 3" label-for="namaFile1">
                        <b-form-input id="namaFile1" placeholder="Masukkan Nama File..." type="text" v-model="dataUploadEvaluasiPelatihan.namafilenilai3"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <b-form-group class="mb-3" label="Link Dokumentasi 3" label-for="linkDokumentasi">
                        <b-form-input id="linkDokumentasi" placeholder="Link Dokumentasi..." type="url" v-model="dataUploadEvaluasiPelatihan.linknilai3"></b-form-input>
                    </b-form-group>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <label for="formPhoto6" class="form-label">Upload File 3</label>
                    <input type="file" class="form-control" id="formPhoto6" v-on:change="inputFilePhotoEvaluasi3()">
                    <div class="respond-input-file float-left" id="uploadLoading6"></div>
                    <small class="float-right" style="color: red">* Max File 5 MB</small>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 text-end">
                    <b-button variant="success" type="submit">
                        <i class="fas fa-check"></i>
                        &nbsp;
                        <b>Simpan</b>
                    </b-button>
                </div>
            </div>
        </b-form>
    </b-modal>
    
    <b-modal v-model="showModal.showPhoto" :title="'Photo Peserta - ' + photoNameActive" title-class="text-black font-18" body-class="p-3" size="md" hide-footer @hidden="closePhoto()">
        <img
            style="display: block; width: 50%; height: auto; margin: 0 auto;"
            :src="photoActive"
        >
    </b-modal>


</template>
